

export const clientTypeId = {
    title: "Tipo de Cliente",
    type: "number",
    oneOf: [
        { title: "Comercial", const: 3 },
        { title: "PYME - RNC", const: 2 },
        { title: "PYME - Cédula", const: 4 },
        { title: "Personal", const: 1 },
    ]
};

export const leadChannel = {
        title: "Canal de entrada del lead",
        type: "string",
        enumNames: ["Instagram", "LinkedIn", "Página Web", "SMS", "Teléfono", "Twitter", "Visita Presencial", "Whatsapp", "Referido"],
        enum: ["Instagram", "LinkedIn", "Pagina Web", "SMS", "Telefono", "Twitter", "Visita Presencial", "Whatsapp", "Referido"],
}


export const multiFileUploadField = {
    schema: {
        title: " ",
        type: "array",
        items: {
            type: "object",
            properties: { file: { title: "", type: "number" }, }
        }
    },
    uiSchema: {
        "classNames": "array-field-vertical",
        "items": { "file": { "ui:field": "FileField" } }
    },
    mapping: (target) => ({
        array: target,
        map: { "fileId": "file" }
    })
};

export const tipoIdentificacionPersonal = {
    title: "Tipo de Identificación",
    type: "number",
    oneOf: [
        { title: "Cédula", const: 1 },
        { title: "Pasaporte", const: 2 },
        { title: "Id Extranjero", const: 3 },
    ],
};

export const tipoIdentificacionComercial = {
    title: "Tipo de Identificación",
    type: "number",
    oneOf: [
        { title: "RNC", const: 4 },
    ],
    default: 4
};


export const preferredBranchId = {
    title: "Oficina de Preferencia",
    type: "number",
    lookup: {
        api: 'branches',
        resource: "Oficinas",
        id: 'id',
        label: 'name'
    }
};

// UCS contact agents come from the backend (api/form-lookup/ucs-contact-agents), which
// keeps them in sync with UCS getContactAgents for every branch (#10403). The stored
// value is the agent name (clients[].ucsContactAgentCode), as before.
export const ucsContactAgentLookup = {
    title: "UCS Contact Agent",
    type: "string",
    lookup: {
        api: 'ucs-contact-agents',
        params: { branchId: { field: 'preferredBranchId' } },
        resource: "Agentes",
        id: 'id',
        label: 'label',
        clearIfMissing: true,
    },
};

// Read-only display of ucsContactAgent in forms where preferredBranchId is no longer
// editable (already set at intake). Plain text on purpose: an agent that later leaves
// UCS must not make older cases fail validation.
export const ucsContactAgentAllOptions = {
    title: "UCS Contact Agent",
    type: "string",
};

// Builds the { "preferredBranchId": {...} } dependency fragment that turns on the
// "ucsContactAgent" dropdown (filtered by the selected branch) once preferredBranchId
// is selected. extraProperties/extraDependencies let callers keep whatever else is
// conditioned on preferredBranchId (e.g. assignmentsSchema).
export function buildUcsContactAgentDependency(extraProperties = {}, extraDependencies = {}) {
    return {
        properties: {
            "ucsContactAgent": ucsContactAgentLookup,
            ...extraProperties,
        },
        required: ["ucsContactAgent"],
        ...(Object.keys(extraDependencies).length ? { dependencies: extraDependencies } : {}),
    };
}



export const boolYesNoType = {
    type: "boolean",
    oneOf: [
        { title: "Si", const: true },
        { title: "No", const: false },
    ],
}

export const strYesNoNAType = {
    type: "string",
    oneOf: [
        { title: "Si", const: "Si" },
        { title: "No", const: "No" },
        { title: "N/A", const: "N/A" },
    ],
}



export const readOnlyFileUI = {
    'ui:field': 'FileField',
    'ui:hideOnEmpty': true,
    'ui:readonly': true,
    'ui:titleAsLink': true,
}

export const contractSigner = {
    title: "Contrato elaborado por:",
    type: "number",
    oneOf: [
        { title: "Oficial de Relaciones", const: 0 },
        { title: "Oficial de Legal", const: 1 },
    ]
};


export function mergeObjects(...objects) {
    return {
        title: objects[0].title,
        type: 'object',
        properties: objects.reduce((_, o) => {
            Object.assign(_, o.properties || {});
            return _;
        }, {}),
        required: objects.reduce((_, o) => {
            _.push(...(o.required || []));
            return _;
        }, []),
        dependencies: objects.reduce((_, o) => {
            Object.assign(_, o.dependencies || {});
            return _;
        }, {}),
    }
}

export const financialCertSchema = {
    title: "",
    description: "Certificado Financiero",
    type: "object",
    properties: {
        "inversionEstimadaRD": {
            title: "Monto estimado inversión Certificados en RD",
            type: "number",
        },
        "origenFondosRD": {
            title: "Origen de fondos en RD",
            type: "string",
            enumNames: [
                "Ahorros provenientes del salario",
                "Ahorros por ingresos regulares",
                "Herencia",
                "Regalo",
                "Venta de inmueble",
                "Venta de vehículo",
                "Liquidación de otra inversión",
                "Otro",
                "No aplica"
            ],
            enum: [
                "Ahorros provenientes del salario",
                "Ahorros por ingresos regulares",
                "Herencia",
                "Regalo",
                "Venta de inmueble",
                "Venta de vehiculo",
                "Liquidacion de otra inversion",
                "Otro",
                "No aplica"
            ],
        },
        "tasaCambio": {
            title: "Tasa de cambio en RD",
            type: "number",
            exclusiveMinimum: 0
        },
    },
    dependencies: {
        "origenFondosRD": {
            allOf: [
                {
                    if: {
                        properties: {
                            "origenFondosRD": {
                                const: "Otro",
                            },
                        }
                    },
                    then: {
                        properties: {
                            "origenFondosRDOtro": {
                                title: "Otro",
                                type: "string"
                            },
                        }, required: ["origenFondosRDOtro"]

                    }
                }
            ]
        },
    },
    required: ["inversionEstimadaRD", "origenFondosRD", "tasaCambio"]
}

export const financialCertBusinessSchema = {
    title: "Certificado Financiero",
    type: "object",
    properties: {
        "inversionEstimadaRD": {
            title: "Monto estimado inversión en RD",
            type: "number",
        },
        "origenFondosRD": {
            title: "Origen de fondos en RD",
            type: "string",
            enumNames: [
                "Ventas",
                "Tesorería",
                "Inversiones anteriores",
                "Otro",
            ],
            enum: [
                "Ventas",
                "Tesoreria",
                "Inversiones anteriores",
                "Otro",
            ],
        },
        "tasaCambio": {
            title: "Tasa de cambio en RD",
            type: "number",
            exclusiveMinimum: 0
        },
    },
    dependencies: {
        "origenFondosRD": {
            allOf: [
                {
                    if: {
                        properties: {
                            "origenFondosRD": {
                                const: "Otro",
                            },
                        }
                    },
                    then: {
                        properties: {
                            "origenFondosRDOtro": {
                                title: "Especifique",
                                type: "string"
                            },
                        }, required: ["origenFondosRDOtro"]

                    }
                }
            ]
        },
    },
    required: ["inversionEstimadaRD", "origenFondosRD", "tasaCambio"]
}

export const solicitudPrestamoSchema = {
    title: " ",
    description: "Solicitud Préstamo",
    type: "object",
    properties: {
        "facilidadesSolicitadas": {
            title: " ",
            description: "Facilidades solicitadas",
            type: "object",
            properties: {
                "proposito": {
                    title: "Propósito",
                    type: "string",
                },
                "descripcionFacilidades": {
                    title: " ",
                    description: "Descripción de facilidades (sólo aplica para líneas de crédito)",
                    type: "array",
                    maxItems: 5,
                    "items": {
                        "type": "object",
                        properties: {
                            "numFacilidad": {
                                title: "No. de Facilidad",
                                type: "string",
                            },
                            "descripcion": {
                                title: "Descripción",
                                type: "string",
                            },
                            "tipoFacilidad": {
                                title: "Tipo de Facilidad",
                                type: "string",
                                enumNames: [
                                    "Consumo",
                                    "Comercial- Micro",
                                    "Descuento nómina",
                                    "Hipotecario",
                                ],
                                enum: [
                                    "Consumo",
                                    "Comercial- Micro",
                                    "Descuento nomina",
                                    "Hipotecario",
                                ],
                            },
                            "montoAprobado": {
                                title: "Monto Aprobado (si aplica)",
                                type: "number",
                            },
                            "montoUtilizado": {
                                title: "Monto Utilizado (si aplica)",
                                type: "number",
                            },
                            "montoPropuesto": {
                                title: "Monto Propuesto",
                                type: "number",
                            },
                            "tasa": {
                                title: "Tasa",
                                type: "number",
                            },
                            "formaPago": {
                                title: "Forma de Pago",
                                type: "string",
                                enumNames: [
                                    "Ingresos por negocio",
                                    "Ingresos por salario",
                                    "Intereses generados",
                                    "Otro",
                                ],
                                enum: [
                                    "Ingresos por negocio",
                                    "Ingresos por salario",
                                    "Intereses generados",
                                    "Otro",
                                ],
                            },
                            "cuotaEstimada": {
                                title: "Cuota Estimada",
                                type: "string",
                            },
                            "seraCancelado": { title: "¿Será Cancelado?", ...boolYesNoType },
                        },
                    },
                },
                "incluyeGarantia": { title: "¿Incluye garantía?", ...boolYesNoType },
                "comentarios": {
                    title: "Comentarios",
                    type: "string",
                }
            },
            dependencies: {
                "incluyeGarantia": {
                    allOf: [{
                        if: { properties: { "incluyeGarantia": { const: true } } },
                        then: {
                            properties: {
                                "incluyeGarantiaSolidaria": { title: "¿Incluye garantía solidaria?", ...boolYesNoType },
                                "tipoGarantia": {
                                    title: "Tipo de Garantía",
                                    type: "string",
                                    enumNames: ["Garantía Solidaria", "Descuento de Nómina", "Hipotecario", "Prendaria", "Múltiples", "Otra"],
                                    enum: ["Garantia Solidaria", "Descuento de Nomina", "Hipotecario", "Prendaria", "Multiples", "Otra"],
                                },
                            }
                        }
                    }]
                },
            }
        },
    },
}

export const tipoDeEntidad =  {
    title: "Tipo de Entidad",
    type: "string",
    enum: [
        "S.A., S.A.S. o S.R.L.",
        "Empresa extranjera",
        "E.I.R.L.",
        "Asociacion sin fines de lucro / ONG",
        "Cooperativa",
        "Empresa Gubernamental",
        "Consorcio",
        "Fideicomiso",
        "Fondos de inversion",
    ],
    enumNames: [
        "S.A., S.A.S. o S.R.L.",
        "Empresa extranjera",
        "E.I.R.L.",
        "Asociación sin fines de lucro / ONG",
        "Cooperativa",
        "Empresa Gubernamental",
        "Consorcio",
        "Fideicomiso",
        "Fondos de inversión",
    ],
}

export const descripcionFacilidadesBusiness = {
    title: " ",
    description: "Descripción de facilidades (sólo aplica para líneas de crédito)",
    type: "array",
    maxItems: 5,
    items: {
        type: "object",
        properties: {
            "numFacilidad": {
                title: "No. de Facilidad",
                type: "string",
            },
            "descripcion": {
                title: "Descripción",
                type: "string",
            },
            "tipoFacilidad": {
                title: "Tipo de Facilidad",
                type: "string",
                enumNames: [
                    "Consumo",
                    "Comercial- Micro",
                    "Descuento nómina",
                    "Hipotecario",
                ],
                enum: [
                    "Consumo",
                    "Comercial- Micro",
                    "Descuento nomina",
                    "Hipotecario",
                ],
            },
            "montoAprobado": {
                title: "Monto Aprobado (si aplica)",
                type: "string",
            },
            "montoUtilizado": {
                title: "Monto Utilizado (si aplica)",
                type: "string",
            },
            "montoPropuesto": {
                title: "Monto Propuesto",
                type: "string",
            },
            "tasa": {
                title: "Tasa",
                type: "number",
            },
            "formaPago": {
                title: "Forma de Pago",
                type: "string",
                enumNames: [
                    "Ingresos por negocio",
                    "Ingresos por salario",
                    "Intereses generados",
                    "Otro",
                ],
                enum: [
                    "Ingresos por negocio",
                    "Ingresos por salario",
                    "Intereses generados",
                    "Otro",
                ],
            },
            "cuotaEstimada": {
                title: "Cuota Estimada",
                type: "string",
            },
            "seraCancelado": { title: "¿Será Cancelado?", ...boolYesNoType },
        },
    },
}

export const employerOcupation = [
  " Asesor de Prestmos ",
  " Asistencia de oficina ",
  " Asistente de oficina ",
  " Ayuda  de oficina ",
  " Comisario Suplente de Correcional ",
  " Investigador / ambiental ",
  "33020 Florida ",
  "Abogado ",
  "Abogado Asociado ",
  "Abogado En Leyes",
  "Abogado en Leyes ",
  "Abogado en Leyes - Director Servicio  Legal  ** (Director Legal Srvs) ",
  "Abogado-en-leyes",
  "Abogado-en-Leyes",
  "Abogado-en-Leyes ",
  "Abogados- en- Leyes ",
  "Acabado de muebles",
  "Academico ",
  "Actor ",
  "Actriz ",
  "Actuarial aprendiz ** (Trainee Actuarial) ",
  "Actuario ",
  "Actuarios",
  "Administracion ",
  "Administracion de Cartera ",
  "Administracion de Hospital ",
  "Administracion de Ventas ",
  "Administracion Servicio Cliente / Tecnico Oermitido ",
  "Administracion Servicios Corporativo ",
  "Administracion Sistema Gerencial de red ",
  "Administrador ",
  "Administrador - Servicio Gubernamental ",
  "Administrador Base datos Snr ",
  "Administrador Central ",
  "Administrador de Administracion ",
  "Administrador de base de datos ",
  "Administrador de Cuentas ",
  "Administrador de Deportes ",
  "Administrador de Efectivo ",
  "Administrador de Escuela ",
  "Administrador de facultad ",
  "Administrador de Impuesto ",
  "Administrador de Investigacion ",
  "Administrador de Laboratorio ",
  "Administrador de Municipio ",
  "Administrador de Oficina ",
  "Administrador de Red ",
  "Administrador de Seguridad ",
  "Administrador de Seguro ",
  "Administrador de Sistema ",
  "Administrador de Sistemas ",
  "Administrador de Vino ",
  "Administrador del Equipo ",
  "Administrador Edudcacional ",
  "Administrador Maritimo ",
  "Administrador Minorista ",
  "Administrador Recursos Humanos ",
  "Administrador Sistema de Computo ",
  "Administrador y Superintendentes de Correo",
  "Administrador/Coordinador",
  "Administrativo ",
  "Administrativo - Oficial de Registros",
  "Administrdor Ejecutivo ",
  "Admisiones  de empleados",
  "Agencia de Viajes Medio Tiempo ",
  "Agente ",
  "Agente Aeropuerto ",
  "Agente Bienes Raices ",
  "agente Bienes Raices ",
  "Agente Conexion dis/re",
  "Agente de Aerolinea ",
  "Agente de Anualidad y Vida ",
  "Agente de Bienes Raices ",
  "Agente de Cargo ",
  "Agente de Centro de Llamada ",
  "Agente de Coleccion ",
  "Agente de Distrito ",
  "Agente de Envio ",
  "Agente de Llamada ",
  "Agente de Operacion ",
  "Agente de Policia ",
  "Agente de Reservacion ",
  "Agente de Reservacion/oficial de coordinador ",
  "Agente de Seguro ",
  "Agente de Turno ",
  "Agente de Venta de Reservacion ",
  "Agente de Ventas",
  "Agente de Viaje ",
  "Agente detective ",
  "Agente Ejecutivo ",
  "Agente Envio / Mecanico ",
  "Agente Investigador ",
  "Agente Lider ",
  "Agente oficina frontal ",
  "Agente Portero ",
  "Agente Retirado ",
  "Agente Seguro Independiente ",
  "Agente Servicio al Cliente ",
  "Agentes de carga y flete",
  "Agentes de Ingresos ",
  "Agentes de Operaciones ",
  "Agentes y Corredores de Bienes Ra?ces",
  "Agentes y gerentes comerciales de artistas",
  "Agricultores y Ganaderos",
  "Agrimensor ",
  "Aistente Economo ",
  "Aistente Gerente de Credito ",
  "Ajustador de Perdidas ",
  "Ajustador de Reclamo ",
  "Ajustador de Seguro ",
  "Ajustador Reclamo Insertado ",
  "Ajustadores de reclamos",
  "Albanil ",
  "Albanil de Construccion ",
  "Albañil",
  "Alguaciles",
  "Almacen Clerk ",
  "Ama de Casa ",
  "Ama de casa ",
  "ama de Casa ",
  "ama de Casa ** Housewife ",
  "Ama de Casa / Retirada ",
  "Ama de casa jubilada ",
  "Ama de casa/ Empresaria ",
  "ama de Llaves",
  "Analisis Actuario ",
  "analisis de Compensacion y beneficios Snr ",
  "Analisis de Sistemas ",
  "Analisis de Soporte ",
  "Analista Actuario ",
  "Analista Control Calidad Senior ",
  "analista Control de Calidad ",
  "Analista de Calidad ",
  "Analista de computo ",
  "Analista de Computo ",
  "Analista de Comunicacion ",
  "Analista de consumo ",
  "analista de control de Reservacion ",
  "Analista de Cuenta",
  "Analista de Cuenta ",
  "Analista de datos ",
  "Analista de Estadistica ",
  "Analista de Inversion ",
  "Analista de Investigacion ",
  "Analista de Laboratorio ",
  "Analista de Negocio ",
  "Analista de Nomina ",
  "Analista de Presupuesto ",
  "Analista de Recursos Humanos ",
  "Analista de Rendimiento ",
  "Analista de Seguro ",
  "Analista de sistema ",
  "Analista de Sistema Senior ",
  "Analista de Sistemas ",
  "Analista de Tarifa ",
  "Analista de Ventas",
  "Analista Financiero ",
  "Analista financiero ",
  "Analista Him ",
  "Analista Seguridad Snr ",
  "Analista/Programador ",
  "analistad de Politicas ",
  "Analistas de Investigación de Mercado",
  "Analistas de Investigación de Operaciones",
  "Analistas de seguridad ",
  "Analistas de Sistemas de Red y Comunicaciones de Datos",
  "Anestesiólogos",
  "Anestesista ** (Anaesthetist)",
  "Anfitriona",
  "Anfitriona de Fiesta ",
  "Anticuario ",
  "Arbitro ",
  "Árbitros",
  "Archivador ",
  "Archivero ",
  "Archivos Materiales de Oficina ",
  "Arqueologo ",
  "Arquitecto ",
  "Arquitecura ",
  "Arrendatario que queda ",
  "Artes",
  "Articulos Dentales y espejuelos Contratista ",
  "Artista ",
  "Artista (Pintor)",
  "Artista de Trabajos en madera ",
  "Artista Grafico ",
  "Artista Grafico/ Coordinador de Media ",
  "Artista/Musico ",
  "Asegurador de Vida",
  "Asegurador Publico ",
  "Aseguradora",
  "Asesor de Aviacion ",
  "Asesor de Inversion ",
  "Asesor de Negocios",
  "Asesor de Novia",
  "Asesor de Prision ",
  "Asesor de Salud ",
  "Asesor de Seguro ",
  "Asesor Financiero ",
  "Asesor Legal ",
  "Asesor Legal/ Abagado Legal ",
  "Asesor Medico ",
  "Asesor Parte Automovilisticas",
  "Asesor Residente ",
  "Asesor Senior ",
  "Asis Medio Tiempo ",
  "Asistencia Administrador ",
  "Asistencia de oficina ",
  "Asistente  de Enfermera ",
  "Asistente Administrador ",
  "Asistente Administrativa ",
  "Asistente Administrativo ",
  "Asistente Administrativo - Finanza ",
  "Asistente administrativo Senior ",
  "Asistente Administrativo y adquisiciones ",
  "Asistente Almacen ",
  "Asistente Aministrador ",
  "Asistente Analista de Politica ",
  "Asistente Arquitectura ",
  "Asistente Ayuda Enferma ",
  "Asistente Banco Personal ",
  "Asistente Contable ",
  "Asistente cuidado Paciente ",
  "Asistente Cuidado Personal ",
  "Asistente de Administracion ",
  "Asistente de Administrador ",
  "Asistente de almacen ",
  "Asistente de Auditoria ",
  "Asistente de Cafeteria ",
  "Asistente de Chef ",
  "Asistente de Comedor",
  "Asistente de Contabilidad ",
  "Asistente de Cuenta",
  "Asistente de Dirctor de Turismo Senior ",
  "Asistente de Enfermera ",
  "Asistente de Enfermera Certificada",
  "Asistente de Enfermera Certificada ** (assistant)",
  "Asistente de Enfermeria ",
  "Asistente de Entrenador",
  "Asistente de Entrenamiento ",
  "Asistente de Estacion ",
  "Asistente de Facilidades ",
  "Asistente de Gerente",
  "Asistente de Gerente ",
  "Asistente de Gerente de recepcion ",
  "Asistente de Habitacion ",
  "Asistente de Ingeniero Control ",
  "Asistente de Investigacion ",
  "Asistente de Lavanderia ",
  "Asistente de Liberia ",
  "Asistente de Llamada ",
  "Asistente de Ministro ",
  "Asistente de Nomina ",
  "Asistente de Oficina ",
  "Asistente de oficina ",
  "Asistente de Operaciones ",
  "Asistente de Ortodoncia ",
  "Asistente de Parqueo ",
  "Asistente de Pastor ",
  "Asistente de Personal ",
  "Asistente de Profesor",
  "Asistente de Programa ",
  "Asistente de Pump ",
  "Asistente de Registro ",
  "Asistente de RRHH",
  "Asistente de Ruta ",
  "Asistente de Sala ",
  "Asistente de sala de estado ",
  "Asistente de Supervisor ",
  "Asistente de Tienda ",
  "Asistente de Ventas ",
  "Asistente de vivienda ",
  "Asistente de Vuelo ",
  "Asistente Dental ",
  "Asistente Disenador ",
  "Asistente Ejecutivo ",
  "Asistente ejecutivo de Hotel ",
  "Asistente en el hogar ",
  "Asistente Enfermeria ",
  "Asistente Especial ",
  "Asistente Farmaceutico ",
  "Asistente Financiero ",
  "Asistente General ",
  "Asistente Gerente de Cambio ",
  "Asistente Gerente de Proyecto ",
  "Asistente Gerente de Sucursal ",
  "Asistente Gerente General ",
  "Asistente Gerente Minorista ",
  "Asistente Gerente Recursos Humanos",
  "Asistente Legal ",
  "Asistente Maestro/a",
  "Asistente Media ",
  "Asistente Medico ",
  "Asistente Mercadeo ",
  "Asistente Mercadeo/Administrativo ",
  "Asistente Nutricionista ",
  "Asistente Personal a CEO ",
  "Asistente Post Oficina ",
  "Asistente Produccion Vinil ",
  "Asistente Ramp ",
  "Asistente Recursos Humanos ",
  "Asistente Relaciones Empleado ",
  "Asistente Servicios Corporativo ",
  "Asistente sistema Calidad ",
  "Asistente Suplidores ",
  "Asistente Tecnico ",
  "Asistente Tesoreria ** (Bursar) ",
  "Asistente Y Estudiante ",
  "Asistente/Estudiante de Enfermera Certificada ",
  "Asistentes Administrativo ",
  "Asistentes de entretenimiento y recreación",
  "Asistentes de mostrador",
  "Asistentes de Pump ",
  "Asistentes Funerarios",
  "Asistentes veterinarios y cuidadores de animales de laboratorio",
  "Asitentes de Doctores ",
  "Asociacion Gestion Cliente ",
  "Asociacion Gestion de fuerza laboral",
  "Asociado ",
  "Asociado Banco Personal ",
  "Asociado Comercial ",
  "Asociado de Almacen ",
  "Asociado de Asesor",
  "Asociado de Banco Minorista ",
  "Asociado de Investigacion ",
  "Asociado de Mercadeo Snr ",
  "Asociado de negocio de RRHH ",
  "Asociado de Reclamos ",
  "Asociado de Susbcripcion ",
  "Asociado Envio politica ",
  "Asociado Gestion ",
  "Asociado Mercadeo ",
  "Asociado Minorista ",
  "Asociado Plan Financiero ",
  "Asociado Senior ",
  "Astronauta",
  "Astronomo ",
  "Atencion Medica en el hogar ",
  "Atleta ",
  "Atletas y competidores deportivos",
  "Auditor ",
  "Auditor Asociado",
  "Auditor de Aplicacion de Efectivo ",
  "Auditor de Cuenta",
  "Auditor de Impuesto ",
  "Auditor de Impuesto Senior ",
  "Auditor de Ingresos ",
  "Auditor Interno ",
  "Auditor Nocturno ",
  "Auditor Senior ",
  "Auditor snr ",
  "Autorizacion Empleado ",
  "Auxiliar de Enfermera ",
  "Auxiliar de Gerente de Proyecto ",
  "Auxiliar de Libreria ",
  "Auxiliar Farmaceutica ",
  "Auxiliar Gerente de Enfermera ",
  "Ayuda Cuidado de Salud ",
  "Ayuda Cuidado Salud ",
  "Ayuda de Salud ",
  "Ayuda domestica ",
  "Ayuda Medical en el hogar ",
  "Ayudante ",
  "Ayudante  de oficina ",
  "Ayudante de Cocina ",
  "Ayudante de Enfermera ",
  "Ayudante de Enfermeria ",
  "Ayudante de Propietario de hogar ",
  "Ayudante Dietista ",
  "Ayudante Domestica ",
  "Ayudante Enfermera ",
  "Azafata",
  "Azafata ",
  "Azafata Promosional ",
  "Bailarin ",
  "Banca en linea/ Oficial canales electricos ",
  "Bancario ",
  "Bancarota para Legal ",
  "Banco Clerk ",
  "Banquero ",
  "Banquero de Inversion ",
  "Banquero Hipoteca",
  "Barbero ",
  "Bebe",
  "Bibliotecario",
  "Bibliotecario legal ",
  "Bibliotecario Tecnologia de Informacion ",
  "Bienes Raices ",
  "Bio Quimico ",
  "Biologo Marino ",
  "Bioquímicos y biofísicos",
  "Bombero ",
  "Botones ",
  "Bu-Mgr regional ",
  "C.E.O",
  "C.R.O",
  "C.S.R",
  "Cabeza de Departamento ",
  "Caddie",
  "Caja ",
  "Caja de Remesas ",
  "Caja/Banquero ",
  "Cajero ",
  "Cajero ** (Cashier)",
  "Cajero / dueno ",
  "Cajero Bancario ",
  "Cajero de Boveda ",
  "Cajero General ",
  "Cajero/Recepcionsta ",
  "Cajeros ",
  "Cajeros (minoristas)",
  "Calidad Topografo ",
  "Camarera",
  "Camarera ",
  "Camarera ** (chambermaid) ",
  "Camarera de Coctel ",
  "Camareras ",
  "Camarero",
  "Camarero ",
  "Camarero/camarera ",
  "Camarero/Representante de Venta ",
  "Camareros y camareras",
  "Camarografo ",
  "Cambio Concesionario ",
  "Cambio de Caja ",
  "Cambio de Operador ",
  "Cambio Entrenador ",
  "Cambio Ingeniero ",
  "Camisera",
  "Campo Coordinador de Ventas ",
  "Campo de Empleado ",
  "CAN ** ",
  "Cantante ",
  "Capas de piso",
  "Capataz",
  "Capataz de Construccion ",
  "Capitan ",
  "Capitan de Barco ",
  "Capitan Piloto ",
  "Capitanes",
  "Cardiologo ",
  "Carniceria ",
  "Carniceros y Cortadores de Carne",
  "Carpintero ",
  "Carpintero Contratado ",
  "Carpintero/Ebanista ",
  "Carpintero/Empleado Propio",
  "Carrera de Caballos- Jinete ",
  "Carro tanque",
  "Carrocería automotriz y reparadores relacionados",
  "Cartero ",
  "Cartografo ",
  "Catedratico  Retirado ",
  "Catedratico / decano Asociado ",
  "Catedratico/Profesor ",
  "Categratico en cirugia",
  "Centro Ayuda Recursos ",
  "Centro de Ninos ",
  "Centro Educacion ",
  "CEO ",
  "CEO / Director",
  "CEO / Director de Manejo ",
  "CEO y Registrador de Companias ",
  "Cerrajero ",
  "Cerrajero / Propio ",
  "Chef ",
  "Chef Contable **",
  "Chef Contable ** ",
  "Chef Contable *** ",
  "Chef Ejecutivo ",
  "Chef/Empleado por su propia cuenta ",
  "Chefs y cocineros",
  "Chofer ",
  "Chofer - Recogida escolar y entrega",
  "Chofer / carpintero",
  "Chofer Aprendiz ",
  "Chofer de Camion",
  "Chofer de Camion ",
  "Chofer de Camion/auto Mecanico ",
  "Chofer de Remolque ",
  "Chofer de Taxi ",
  "chofer de Tractor ",
  "Chofer Empleado por cuenta propia ",
  "Chofer/ Vendedor ",
  "Chofer/Mecanico ",
  "Chofer/Mensajero ",
  "Chofer/Soldador ",
  "Cientifico ",
  "Cientifico Agricola",
  "Cientifico Jubilado ",
  "Cierre de Cuenta",
  "Cirujano ",
  "cirujano dental",
  "Cirujano Ortopeda ",
  "Cirujano Vascular ",
  "Cirujano Veterinario ",
  "Clerk Bancario ",
  "Clerk de Reclamos ",
  "Clerk Visa ",
  "Clero",
  "Clero U.I.S",
  "Clero/Pastor/Sacerdote/Ocupaciones Religiosas",
  "Cliente Bancario ",
  "Cliente Registracion ",
  "cliente senior ",
  "Clinica ",
  "Co Director ",
  "Co propietario ",
  "Co. Director ",
  "co. Secretario ",
  "Cobrador de Factura ",
  "Cobrdor",
  "Cocina ",
  "Cocina / Cocinero ",
  "Cocina /Chofer ",
  "Colectando Factura",
  "Colector ",
  "Colector de Deuda ",
  "Colector de Facturas Senior ",
  "Colector de Impuesto ",
  "Colector de Impuesto Senior ",
  "Comandante ",
  "Comercial ",
  "Comercialista comercial",
  "Comercializacion de divisa ",
  "Comercializando ",
  "Comerciante ",
  "Comerciante **(Merchandiser) ",
  "Comerciante de materias primas",
  "Comerciante Unico ",
  "Comerciante Unico  - Distrito Herbal Life ",
  "Compradores mayoristas y minoristas",
  "Computadora ",
  "Comunidad Administrativo ",
  "Concesionario de Vehiculo ",
  "Condestable del Distrito Especial",
  "Conducir ",
  "Conductor ",
  "Conductor Aprendiz ",
  "Conductor de Montacarga",
  "Conductor de Musica ",
  "Conductor del Chofer ",
  "Conductores de ambulancia y asistentes",
  "Consejera en par ",
  "Consejero ",
  "Conserje ",
  "Conserje de Golf ",
  "Conserjes y limpiadores",
  "Construccion ",
  "Construccion - Empleado Propio ",
  "Constructor ",
  "Constructor de Gabinetes",
  "Constructor/Contratador",
  "Consulta Recursos Humanos ",
  "Consultante de Boda ",
  "Consultante de Gestion ",
  "Consultante de Seguro ",
  "Consultante de Viaje ",
  "Consultante Derechos Humanos y Abogado en Leyes",
  "Consultante Publicidad ",
  "Consultante Senior ",
  "Consultor ",
  "Consultor - Computo ",
  "Consultor - Desarollador de Tierra ",
  "Consultor - Independiente ",
  "Consultor ambiental ",
  "Consultor Bienes Raices ",
  "Consultor de  TI ",
  "Consultor de Computo ",
  "Consultor de Desarollo de Negocios",
  "Consultor de Entrenamiento ",
  "Consultor de entretenimiento ",
  "Consultor de Gestion ",
  "Consultor de Negocios ",
  "Consultor de Ventas ",
  "Consultor de Ventas al detalle ",
  "Consultor de Ventas Senior ",
  "Consultor de Viaje ",
  "consultor de Viaje ",
  "Consultor Disenador de Interior ",
  "Consultor Entrenamiento / Adminsitrativo ",
  "Consultor financiero ",
  "Consultor Gestion de Energia ",
  "Consultor Gestion de PRoyecto ",
  "Consultor Independiente ",
  "Consultor Investigacion ",
  "Consultor Mercadeo ",
  "Consultor Neurocirujano",
  "Consultor pas ",
  "Consultor Retirado ",
  "Consultor Vjh ",
  "Consultor/Tecnologo de alimentos",
  "Consultores de Viajes ",
  "Contabilidad ",
  "Contabilidad Anr ",
  "Contabilidad de Gestion ",
  "Contable",
  "Contable ",
  "Contable Certificado",
  "Contable Clerk ",
  "Contable Clerks ",
  "Contable Corporativo ",
  "Contable de Ingresos ",
  "Contable de proyecto ",
  "Contable Financiero ",
  "Contable Gestion de Deuda ",
  "Contable senior ",
  "Contable Senior ",
  "Contable snr ",
  "Contable/Consejal ",
  "Contables ",
  "Contador Divisional",
  "Contador Publico ",
  "Contadores P?blicos / Contadores P?blicos Certificados",
  "Contanble Junior ",
  "Contratador de Construccion ",
  "Contratador de Construccion/Empleador Propio ",
  "Contratista ",
  "Contratista / Especialista en construccion ",
  "Contratista de Seguridad ",
  "Contratista de Tejado ",
  "Contratista de Ventas ",
  "Contratista de vivienda ",
  "Contratista Electrico ",
  "Contratista General ",
  "Contratista Jpsco ",
  "Control de Calidad ",
  "Control de Negocios ",
  "Controlador de Plagas ",
  "Controlador Financiero ",
  "Controlador Trafico Aereo",
  "Coordianador de Compra/ Asistente de Impuestos ",
  "Coordinador  Minorista ",
  "Coordinador / Administrador Operaciones ",
  "Coordinador / facilitador ",
  "Coordinador Acreditador de Calidad ",
  "Coordinador Administrativo ",
  "Coordinador de Boda ",
  "Coordinador de Calidad ",
  "Coordinador de Cobro ",
  "Coordinador de datos ",
  "Coordinador de Entretenimiento ",
  "Coordinador de Entretenimiento / DJ ",
  "Coordinador de eventos",
  "Coordinador de Facilidades ",
  "Coordinador de fletes ",
  "Coordinador de Investigacion ",
  "Coordinador de Negocios",
  "Coordinador de Nomina ",
  "Coordinador de Operacion",
  "Coordinador de Programa ",
  "Coordinador de Proyecto ",
  "Coordinador de Recursos de Carerra ",
  "Coordinador de Servicio ",
  "Coordinador de Ventas ",
  "Coordinador de ventas y reservaciones ",
  "Coordinador Inst y Electricista ",
  "Coordinador Opreacion Marina ",
  "Coordinador Programa Ean ",
  "Coordinador Regional ",
  "Coordinador Registro Medico ",
  "Cordinador de Entrenamiento ",
  "Cordinador Tecnico ",
  "coreografo de Baile ",
  "Coreógrafos",
  "Corporal ",
  "Corredor ",
  "Corredor de aduana ",
  "Corredor de Bienes Raices ",
  "Corredor de Seguro ",
  "Cortador ",
  "Cortador de Cana ",
  "Cortador de Jardin ",
  "Corte",
  "Cosmetologa / Maquillista ",
  "Cosmetologao **(Cometologist) ",
  "Costurero ",
  "Costurero/ Fabricante de Vestidos ",
  "Credito Corporativo Gestion Senior ",
  "Credito de Inversion ",
  "Credito Gerente General ",
  "Credito Senior ",
  "Criador Nocturno ",
  "Criadores de animales y entrenador",
  "Cronometro ",
  "Cuenta",
  "Cuenta Compartida ",
  "Cuenta Junior ",
  "Cuenta Por pagar empleado ",
  "Cuentas de Supervisor ",
  "Cuentas Ejecutivas ",
  "Cuentas Empleado Recibidas ",
  "Cuentas Empleados ",
  "Cuentas Recibidas",
  "Cuentas Recibidas ",
  "Cuerpo de Policia ",
  "Cuidado de Ninos",
  "Cuidado en el Hogar ",
  "Cuidador ",
  "Cuidador Floral",
  "Dador de Cuidado ",
  "Dador de Cuidado de Salud ",
  "Dador de Cuidado Medio Tiempo ",
  "DEA Bienes Raices ",
  "Decano ",
  "Decano de diciplina ",
  "Decorador de Interiores",
  "Dentisa ",
  "Departamento de Gerencia ",
  "Departamento Gerente de Ventas",
  "Departamento principal diseno y decoraciones ",
  "Dermatologo ",
  "Des-empleado ",
  "Desarollador /analista Software ",
  "Desarollador de Negocio ",
  "Desarollador de Sitio Web ",
  "Desarollador de Software",
  "Desarollo de Comunidad ",
  "Desempleado",
  "Desempleado ",
  "Desempleado ** (Unemployed)",
  "Desempleado actualmente ",
  "Detallista ",
  "Detectives privados e investigadores",
  "Dietista ",
  "Dietista Registrada ",
  "Dietista/Nutricionista ",
  "Dietistas y Nutricionistas",
  "Difunto",
  "Diplomatico Junior ",
  "Director ",
  "Director / Desarollo Negocios - VP ",
  "Director administrativo ",
  "Director Ceo",
  "Director Comida del hotel ",
  "Director Compania/Gestion de Equipo ",
  "Director de Arte ",
  "Director de Cine ",
  "Director de Compania ",
  "Director de Comunicacion y pr ",
  "Director de Control de Calidad ",
  "Director de Escuela ",
  "Director de Finanza + cuentas ",
  "Director de gestion ",
  "Director de Gestion ",
  "Director de Gestion dueno ",
  "Director de Gestion/Dueno ",
  "Director de Impuestos ",
  "Director de Int ",
  "Director de Investigacion ",
  "Director de Operaciones ",
  "Director de Pension ",
  "Director de Proyecto ",
  "Director de Pur ",
  "Director de seguridad contra incendios",
  "Director de Tecnologia de Información",
  "Director de Venta ** (sale) ",
  "Director de Ventas ",
  "Director de Ventas Corporativas ",
  "Director Ejecutivo ",
  "Director Ejecutivo - Finanzas y Administrativo ",
  "Director Financiero ",
  "Director Funebre ",
  "Director General ",
  "Director Interino",
  "Director Mercadeo ",
  "Director Operativo ",
  "Director Proceso y TI ",
  "Director Propio ",
  "Director Proyectos Especiales ",
  "Director Regional ",
  "Director senior ",
  "Director Snr ",
  "Director Tecnico ",
  "Director y Hr Administrativo ",
  "Director/Dueno",
  "Director/Productor ",
  "Director/Propietario ",
  "Directores de funerales",
  "Directores de música y compositores",
  "Directores ejecutivos y otros l?deres/ejecutivos s?nior",
  "Disenador ",
  "Disenador de Bizcocho ",
  "Disenador de Interiores ",
  "Disenador de Moda",
  "Disenador de Moda / Cantante ",
  "Disenador de Moda/ Estilista ",
  "Disenador de Ropa ",
  "Disenador Web ",
  "Diseno de Moda ",
  "Diseno Grafico ",
  "Diseno Grafico / Profesor ",
  "Diseno servicios y ventas ",
  "Diseno Tecnico ",
  "Dispensador Optico ",
  "Disponibilidad profesional TI ",
  "Distribuccion De Mariscos ",
  "Distrubuidor de Café Montana azul ",
  "DJ ",
  "Doctor ",
  "Doctor Medico ",
  "Doctor Residente ",
  "Doctor Veterinario ",
  "Doctores",
  "Doctores en Medicina / M?dicos / Cirujanos",
  "Dueno ",
  "Dueno Autobus de gira ",
  "Dueno Compania ",
  "Dueno de Bienes Raices ",
  "Dueno de Restaurante ",
  "Dueno de Supermercado ",
  "Dueno de tienda ",
  "Dueno Medio Tiempo ",
  "Dueno/ Operador de Camnion de basura ",
  "Ebanista",
  "Ebanisteria ",
  "Ecologista",
  "Ecologista ",
  "Ecologista marino ",
  "Economista ",
  "Economista Investigacion ",
  "Economista/Ejecutivo de Negocios ",
  "Editor ",
  "Editor de Entretenimiento ",
  "Editor de Periodico ",
  "Editor de Produccion ",
  "Editores de cine y video",
  "Editores de escritorio",
  "Educacion de Consumo ",
  "Educador ",
  "Educador de vida familiar ",
  "Edudcador Retirado ",
  "Ejecutivo Aerolinea ",
  "Ejecutivo Bancario ",
  "Ejecutivo Cuenta Senior ",
  "Ejecutivo cuenta y mercadeo ",
  "Ejecutivo de adquisiciones ",
  "Ejecutivo de Cuenta",
  "Ejecutivo de Cuenta Nacional ",
  "Ejecutivo de Desarollo de Negocio ",
  "Ejecutivo de Presidencia ",
  "Ejecutivo de Seguridad ",
  "Ejecutivo de Ventas ",
  "Ejecutivo Desarollo de Negocio ",
  "Ejecutivo Mercadeo ",
  "Ejecutivo-Cuenta",
  "Ejercicio Fisioterapeuta ",
  "Ejrcito US ",
  "Electricista ",
  "Electricista **( Electrician) ",
  "Electricista industrial",
  "Electrico Automovilistico ",
  "Electrico- Automovilistico ",
  "Embalsamador",
  "empacador ",
  "Empacador de alimento",
  "Empacadores",
  "Emplado Propio - Profesor ",
  "Empleado ",
  "Empleado  Administrativo ",
  "Empleado - Propio ",
  "Empleado Ayudante de Familia ",
  "Empleado Construccion ",
  "Empleado Contabilidad snr/ Tecnico Ecg ",
  "Empleado Contable/Supervisor ",
  "Empleado Contratado ",
  "Empleado Control de Equipo ",
  "Empleado Corredor de Aduana ",
  "Empleado Cuenta Senior ",
  "Empleado Cuentas General ",
  "Empleado Cuidado Directo ",
  "Empleado de Almacen ",
  "Empleado de Compra ",
  "Empleado de Contabilidad Snr ",
  "Empleado de datos ",
  "Empleado de datos/ Comerciante ",
  "Empleado de Despacho ",
  "Empleado de fabrica ",
  "Empleado de flete ",
  "Empleado de Hipoteca ",
  "Empleado de Hotel ",
  "Empleado de Impuesto ",
  "Empleado de Inventario ",
  "Empleado de ley ",
  "Empleado de Mantenimiento ",
  "Empleado de negocios nuevo snr ",
  "Empleado de oficina ",
  "Empleado de Operaciones ",
  "Empleado de Piso ",
  "Empleado de Presentacion ",
  "Empleado de Presentacion/ Mecanografo ",
  "Empleado de Prestamo ",
  "Empleado de Produccion ",
  "Empleado de Red ",
  "Empleado de Registro ",
  "Empleado de Registros ",
  "Empleado de Remesas ",
  "Empleado de Salud ",
  "Empleado de Sanidad ",
  "Empleado de Tienda ",
  "Empleado de Turno ",
  "Empleado de Ventas ",
  "Empleado de Ventas snr ",
  "Empleado de Vivienda ",
  "Empleado de vuelo/Operador ",
  "Empleado Domestico ",
  "Empleado en metal ",
  "Empleado entrada de datos ",
  "Empleado Frontal ",
  "Empleado General ",
  "Empleado Inventario ",
  "Empleado Inventario/Compra ",
  "Empleado Junior ",
  "Empleado Legal ",
  "Empleado Negocios Nuevos ",
  "Empleado Pagable ",
  "Empleado Pensionado ",
  "Empleado Personal ",
  "Empleado Postal ",
  "Empleado Propio ",
  "Empleado propio ",
  "Empleado Propio -  Camarero ",
  "Empleado Propio -  Trabajdor en Construccion ",
  "Empleado Propio - Abogado ",
  "Empleado Propio - Actor ",
  "Empleado Propio - Administrador ",
  "Empleado Propio - Administrador de Base de Datos ",
  "Empleado Propio - Administrador de Sistema ",
  "Empleado Propio - Administrativo ",
  "Empleado Propio - Agente Inmobiliario ",
  "Empleado Propio - Agnte ",
  "Empleado Propio - Albanil ",
  "Empleado Propio - albanil ",
  "Empleado Propio - Ama de casa ",
  "Empleado Propio - Ama de Llaves ",
  "Empleado Propio - Animador ",
  "Empleado Propio - Arbitro ",
  "Empleado Propio - Arquitecto ",
  "Empleado Propio - Artesano ",
  "Empleado Propio - Artista ",
  "Empleado Propio - Artista Geografico ",
  "Empleado Propio - Asegurador ",
  "Empleado Propio - Asesor Financiero ",
  "Empleado Propio - Atleta ",
  "Empleado Propio - Auditor ",
  "Empleado Propio - Bailarin ",
  "Empleado Propio - Banquero ",
  "Empleado Propio - Barbero ",
  "Empleado Propio - Bibliotecario ",
  "Empleado Propio - Bombero ",
  "Empleado Propio - Cajero ",
  "Empleado Propio - Camarera ",
  "Empleado Propio - Camarero ",
  "Empleado Propio - Camarero/Camarera ",
  "Empleado Propio - Cantante ",
  "Empleado Propio - Cardiologo ",
  "Empleado Propio - Carnicero ",
  "Empleado Propio - Carpintero ",
  "Empleado Propio - Cerrajero ",
  "Empleado Propio - Chef ",
  "Empleado Propio - Chofer ",
  "Empleado Propio - Chofer de Camion ",
  "Empleado Propio - chofer de Taxi ",
  "Empleado Propio - Comerciante ",
  "Empleado Propio - Comida y Bebida",
  "Empleado Propio - Consejero ",
  "Empleado Propio - Conserje ",
  "Empleado Propio - Conservador ",
  "Empleado Propio - Consultor ",
  "Empleado Propio - Consultor Financiero ",
  "Empleado Propio - Contable ",
  "Empleado Propio - Contratista ",
  "Empleado Propio - Contratista de  electricidad ",
  "Empleado Propio - Contratista de transporte",
  "Empleado Propio - Corredor de Aduana ",
  "Empleado Propio - Corredor de Aduanas ",
  "Empleado Propio - Cosmetologa ",
  "Empleado Propio - Costurera ",
  "Empleado Propio - Cuidador ",
  "Empleado Propio - Deliniante ",
  "Empleado Propio - Dentista ",
  "Empleado Propio - Dermatologo ",
  "Empleado Propio - Desarollador de web ",
  "Empleado Propio - Director de Arte ",
  "Empleado Propio - Director de cine",
  "Empleado Propio - Director de Funeria ",
  "Empleado Propio - Director General ",
  "Empleado Propio - Disenador de Interiores ",
  "Empleado Propio - Disenador de moda ",
  "Empleado Propio - Disenador Grafico ",
  "Empleado Propio - Doctor ",
  "Empleado Propio - Ebanista ",
  "Empleado Propio - Economista ",
  "Empleado Propio - Editor ",
  "Empleado Propio - Educador ",
  "Empleado Propio - Ejecutivo ",
  "Empleado Propio - Electricista ",
  "Empleado Propio - Empleado ",
  "Empleado Propio - Empleado de Mercadeo ",
  "Empleado Propio - Empresario ",
  "Empleado Propio - Encargado de Reparar Trabajo ",
  "Empleado Propio - Enfermera ",
  "Empleado Propio - Entrenador ",
  "Empleado Propio - Entrenador Personal  ",
  "Empleado Propio - Escritor ",
  "Empleado Propio - Estudiante ",
  "Empleado Propio - Examinador ",
  "Empleado Propio - Fabricante ",
  "Empleado Propio - Fabricante de Vestido ",
  "Empleado Propio - Fabricante de zapato ",
  "Empleado Propio - Farmaceutico ",
  "Empleado Propio - fisioterapeuta ",
  "Empleado Propio - Fotografo ",
  "Empleado Propio - Geografo ",
  "Empleado Propio - Gerente ",
  "Empleado Propio - Gerente de Hotel ",
  "Empleado Propio - Gerente de Propiedad ",
  "Empleado Propio - Gerente de Proyecto ",
  "Empleado Propio - Granjero ",
  "Empleado Propio - Guardia de seguridad ",
  "Empleado Propio - Guia ",
  "Empleado Propio - Herrero ",
  "Empleado Propio - Ici ",
  "Empleado Propio - Importador ",
  "Empleado Propio - Ingeniero ",
  "Empleado Propio - Ingeniero civil ",
  "Empleado Propio - Ingeniero Electrico ",
  "Empleado Propio - Ingeniero Sonido ",
  "Empleado Propio - Inspector ",
  "Empleado Propio - Investigador ",
  "Empleado Propio - Jardinero",
  "Empleado Propio - Jinete ",
  "Empleado Propio - Jockey de disco ",
  "Empleado Propio - Joyero ",
  "Empleado Propio - Locutor ",
  "Empleado Propio - Maquillista ",
  "Empleado Propio - Mecanico ",
  "Empleado Propio - Mercadeo ",
  "Empleado Propio - Mesero ",
  "Empleado Propio - Ministro de Religion ",
  "Empleado Propio - Minorista ",
  "Empleado Propio - Modista ",
  "Empleado Propio - Musico ",
  "Empleado Propio - Negociante ",
  "Empleado Propio - Obrero ",
  "Empleado Propio - Oficial de Aduanas",
  "Empleado Propio - Oficial del ejercito ",
  "Empleado Propio - Oficial Relaciones Publica ",
  "Empleado Propio - Operador de Taxi ",
  "Empleado Propio - Operador Ppv ",
  "Empleado Propio - Panadero ",
  "Empleado Propio - Para legal ",
  "Empleado Propio - Pastor ",
  "Empleado Propio - Patologo ",
  "Empleado Propio - Pediatra ",
  "Empleado Propio - Peluquera ",
  "Empleado Propio - Peluquero ",
  "Empleado Propio - Periodista ",
  "Empleado Propio - Pescador ",
  "Empleado Propio - Piloto ",
  "Empleado Propio - Planificador de Eventos ",
  "Empleado Propio - Plomero ",
  "Empleado Propio - Principal ",
  "Empleado Propio - Procedimiento de Registro ",
  "Empleado Propio - Productor de Cine ",
  "Empleado Propio - Profesor",
  "Empleado Propio - Programador ",
  "Empleado Propio - Programador de Computo ",
  "Empleado Propio - Propietario de Comercio ",
  "Empleado Propio - Proveedor ",
  "Empleado Propio - Proveedor de Catering ",
  "Empleado Propio - Psicologia ",
  "Empleado Propio - Quimico ",
  "Empleado Propio - Representante Comercial ",
  "Empleado Propio - Representante de venta ",
  "Empleado Propio - Representante ventas Cliente ",
  "Empleado Propio - Sastre ",
  "Empleado Propio - Soldador ",
  "Empleado Propio - Supervisor ",
  "Empleado Propio - Supervisor de Casino ",
  "Empleado propio - Tapicero ",
  "Empleado Propio - Tasador ",
  "Empleado Propio - Tecnico ",
  "Empleado Propio - Tecnico de Laboratorio ",
  "Empleado Propio - Tecnico en Sistema ",
  "Empleado Propio - Tecnologia Informacion ",
  "Empleado Propio - Terapia fisica ",
  "Empleado Propio - Terapista ",
  "Empleado Propio - Terapista Ocupacional ",
  "Empleado Propio - Titular ",
  "Empleado Propio - Trabajador Domestico ",
  "Empleado Propio - Trabajador Social ",
  "Empleado Propio - Tradajador de Produccion ",
  "Empleado Propio - Venta puerta a puerta ",
  "Empleado Propio - Ventas ",
  "Empleado propio - Veterinario ",
  "Empleado propio / Negociante ",
  "Empleado Propio / Tecnologo Medico ",
  "Empleado Propio/ Redundante",
  "Empleado Propio/Automotriz ",
  "Empleado Registros ",
  "Empleado Relacion Invitado",
  "Empleado sala de almacen ",
  "Empleado Salario ",
  "Empleado Senior ",
  "Empleado Servicio al Cliente ",
  "Empleado Servicio Ramp ",
  "Empleado Suplente de la corte ",
  "Empleado Telecomunicaciones ",
  "Empleado Toma de Almacen ",
  "Empleado- Propio ",
  "Empleados de archivo",
  "Empleados de contabilidad / tenedores de libros",
  "Empleados de corretaje",
  "Empleo",
  "Empresaria ",
  "Empresaria - Granjera de Pollo ** (Business Women) ",
  "Empresaria - Propietaria ",
  "Empresaria / Empleada Propia ",
  "Empresaria Mayorista",
  "Empresaria/ Contable ",
  "Empresaria/ Modista",
  "Empresario ",
  "Empresario - Carniceria ",
  "Empresario - Comercializacion ",
  "Empresario - Empleador Propio ",
  "Empresario - Gerente ",
  "Empresario - Muebleria ",
  "Empresario ** (Businessman)",
  "Empresario **(Entrepreneur) ",
  "Empresario / Contratador ",
  "Empresario / Empleado Propio ",
  "Empresario / Empresario ",
  "Empresario Jubilado ",
  "Empresario Mayorista ",
  "Empresario Mercadeo ",
  "Empresario Propio ",
  "Empresario/ Empleado Propio ",
  "Empresario/ Ventas ",
  "Empresario/dueno ",
  "Encargado de Acero ",
  "Encargado de Almacen ",
  "Encargado de Botones ",
  "Enfermera ",
  "Enfermera Certificada ",
  "Enfermera de cuidado de salud ",
  "Enfermera dental ",
  "Enfermera Encargada ",
  "Enfermera General ",
  "Enfermera investigacion ",
  "Enfermera Licenciada Practicante ",
  "Enfermera Practicante ",
  "Enfermera Practicante/ Diario de entrada libre ",
  "Enfermera Registrada ",
  "Enfermera Registrada Jubilada ",
  "Enfermera Registrada/Gerente Sucursal ",
  "Enfermera Registrada/Medio Tiempo ",
  "Enfermera Registrada/partera",
  "Enfermera Residente",
  "Enfermera Retirada ",
  "Enfermera Salud Publica ",
  "Enfermera/ Recepcionista ",
  "Enfermera/Profesor ",
  "Enfermera/Recepcionista ",
  "Enfermeras",
  "Enfermeria ",
  "Ensambladores y Fabricantes",
  "Ensenando ",
  "Entrenador ",
  "Entrenador (Coach) ",
  "Entrenador Carrera de Caballos ",
  "Entrenador de Futbol",
  "Entrenador de Personal ",
  "Entrenador de Producto ",
  "Entrenador de Sistema de T.I ",
  "Entrenador de Tennis ",
  "Entrenador Oficial ",
  "Entrenadores atléticos",
  "Entrenadores de fitness e instructores de aeróbicos",
  "Entrenadores y Scouts",
  "Entrenamiento Administrativo ",
  "Entrenamiento Administrativo y desarollo ",
  "Entrenamiento Cardiaco ",
  "Entrenamiento Servicio al Cliente ",
  "Entretenimiento ",
  "Epidemiólogos",
  "Equipo de contabilidad ",
  "Equipo de enfermeria ",
  "Equipo y Facilidad Gerencial ",
  "Escritor ",
  "Escritor Tecnico ",
  "Escritores y autores",
  "Escritores y corredores de libros de juegos y deportes",
  "Escuela ",
  "Espec?fico militar/Fuerzas armadas",
  "Especialista de Comunicacion ",
  "Especialista de Evaluacion Senior ",
  "Especialista de T.I ",
  "Especialista De TI ",
  "Especialista de TI ",
  "Especialista de Ventas ",
  "Especialista Fitness ",
  "Especialista Grafico Computo ",
  "Especialista informacion/Bibliotecario",
  "Especialista Medico ",
  "Especialista Procesamiento textuales ",
  "Especialista Reparacion Automovilistica ",
  "Especialistas en cuidado de la piel",
  "Especialistas en log?stica y gesti?n de proyectos",
  "Especialistas en seguridad y salud ocupacional",
  "Estadistico ",
  "Esteticista",
  "Estilbador ",
  "Estilista ",
  "Estilista de Pelo ",
  "Estudiante ",
  "Estudiante - 8 anos de edad ",
  "Estudiante - Escuela Secundaria Kingsway ",
  "Estudiante - Uwi ",
  "Estudiante ahora secretaria ",
  "Estudiante Campo y Pista ",
  "Estudiante de Derecho ",
  "Estudiante de Investigacion ",
  "Estudiante Medico ",
  "Estudiante Uwi ",
  "Estudiante y empleado medio tiempo ",
  "Estudiante/Afitrion Medio Tiempo ",
  "Estudiante/Analista Datos Marina ",
  "Estudiante/Analista Investigador Medio Tiempo ",
  "Estudiante/Host TV ",
  "Estudiante/Menor ",
  "Etiquetado ",
  "Evaluacion ",
  "Evaluacion de tierra",
  "Evaluacion Empleado ",
  "Examinador ",
  "Examinador Bancario ",
  "Examinador de Impuesto ",
  "Exportador de musica reggae a japon ",
  "Extracto de Cuenta/ Cartera de Oficial ",
  "Extraoficial ",
  "Fabricador de aluminio",
  "Fabricante ",
  "Fabricante de Casa",
  "Fabricante de Mercado ",
  "Fabricante de prendas de vestir",
  "Fabricante de Vestido",
  "Fabricante de Vestido ",
  "Fabricante de Vestido/ Empleado Propio ",
  "Fabricante de Vestido/Granjero",
  "Fabricante en metal ",
  "Facilitador de Cuidado de ninos ",
  "Facilitador de Negocio Internacional ",
  "Facilitador de Negocios ",
  "Farmaceutica ",
  "Farmaceutica / Empresario Propio ",
  "Farmaceutico ",
  "farmaceutico / Profesor snr ",
  "Fisica ",
  "Fisioterapeuta ",
  "Fisioterapeuta / enfermera de investigacion ",
  "flebotomista",
  "Floristeria",
  "Flujo Propietario del Comercio ",
  "Foniatra ",
  "Fontanero ",
  "Fontanero/empleado Propio ",
  "Fotografo ",
  "Frmacologo ",
  "Funcionario ",
  "Funcionario - Asistente de entrenamiento ",
  "Futbolista ",
  "Garantia de Calidad ",
  "Gastronomia ",
  "Gastronomo ",
  "Genealogista",
  "Generalista RRHH ",
  "Geografo ",
  "Geologo ",
  "Gerente ",
  "Gerente - Aduanas ",
  "Gerente - dueno ",
  "Gerente - Economista ",
  "Gerente - Ventas ",
  "Gerente / Compositor ",
  "Gerente / Dueno ",
  "Gerente / Empresaria ",
  "Gerente / Impermeabilizacion",
  "Gerente / Propio ",
  "Gerente Administracion Personal ",
  "Gerente Administrativo",
  "Gerente Administrativo ",
  "Gerente Adquisicion de lugar",
  "Gerente Ambiental ",
  "Gerente Aprendiz ",
  "Gerente Area de Ventas ",
  "Gerente Asistente de Operaciones ",
  "Gerente Auxiliar ",
  "Gerente Auxiliar de Operaciones ",
  "Gerente Auxiliar de Tesoreria ",
  "Gerente Bancario ",
  "Gerente Banco Personal ",
  "Gerente Bienes Raices ",
  "Gerente Cartera de Prestamo ",
  "Gerente Comercial",
  "Gerente Comisario ",
  "Gerente Contable",
  "Gerente Control Calidad ",
  "Gerente de adquisiciones ",
  "Gerente de Almacen ",
  "Gerente de Asuntos del Paciente",
  "Gerente de Auditoria ",
  "Gerente de Bar ",
  "Gerente de Camara de Escala ",
  "Gerente de Cartera ",
  "Gerente de Cartera/VP ",
  "Gerente de Caso ",
  "Gerente de Chef ",
  "Gerente de Cliente ",
  "Gerente de Compra ",
  "Gerente de Conserje ",
  "Gerente de Construccion ",
  "Gerente de control de calidad del grupo",
  "Gerente de Cuenta ",
  "Gerente de cuenta Clave ",
  "Gerente de Cuentas ",
  "Gerente de Desarollo de Negocio ",
  "Gerente de Desarollo de Negocios",
  "Gerente de Distrito ",
  "Gerente de Enfermera ",
  "Gerente de Entrenamiento ",
  "Gerente de Entretenimiento ",
  "Gerente de Exportacion ",
  "Gerente de Facilidades ",
  "Gerente de Finanza y Administracion ",
  "Gerente de Garantia Grupo ",
  "Gerente de Gimnasio ",
  "Gerente de Granja ",
  "Gerente de Hotel ",
  "Gerente de Informacion y Documento ",
  "Gerente de Ingenieria",
  "Gerente de Inventario ",
  "Gerente de Inversion ",
  "Gerente de Invertario ",
  "Gerente de Lavanderia ",
  "Gerente de Linea General ",
  "Gerente de Mantenimiento ",
  "Gerente de Mercadeo ",
  "Gerente de Mercadeo Ejecutivo ",
  "Gerente de Mercado ",
  "Gerente de Minorista ",
  "Gerente de Municipio ",
  "Gerente de Negocios",
  "Gerente de Negocios ",
  "Gerente de Negocios - Operador de Viaje",
  "Gerente de Nomina ",
  "Gerente de Oficina ",
  "Gerente de Operacion",
  "Gerente de Operacion/Enfermera Re. ",
  "Gerente de Operaciones ",
  "Gerente de Operaciones Jubilado ",
  "Gerente de Personal ",
  "Gerente de Planta ",
  "Gerente de politica ",
  "Gerente de Produccion ",
  "Gerente de Producto ",
  "Gerente de Programa",
  "Gerente de propiedad ",
  "Gerente de Proyecto ",
  "Gerente de Proyectos ",
  "Gerente de Reclamos y Seguro",
  "Gerente de Recursos Humanos ",
  "Gerente de Relacion ",
  "Gerente de Relaciones Comunitarias ",
  "Gerente de Resort ",
  "Gerente de Restaurante ",
  "Gerente de Riesgo ",
  "Gerente de Roaming y Servicios de Operador ",
  "Gerente de RRHH ",
  "Gerente de Segurida de TI ",
  "Gerente de Seguridad ",
  "Gerente de Servicio ",
  "Gerente de Sistema ",
  "Gerente de sistemas de Negocio ",
  "Gerente de Soporte ",
  "Gerente de Soporte de Tierra ",
  "Gerente de Sucursal ",
  "Gerente de Sucursal  ** (Branch) ",
  "Gerente de Tesoreria ",
  "Gerente de Tienda ",
  "Gerente de Transporte ",
  "Gerente de Transporte y seguridad ",
  "Gerente de Unidad ",
  "Gerente de Ventas",
  "Gerente Desarollo de Empleado ",
  "Gerente Directo ",
  "Gerente Editorial ",
  "Gerente Empleado ",
  "Gerente Financiero ",
  "Gerente General ",
  "Gerente General Suplente ",
  "Gerente Hr ",
  "Gerente Interino",
  "Gerente Junior ",
  "Gerente Libro Texto ",
  "Gerente Mercadeo ",
  "Gerente Nocturno ",
  "Gerente Oficina Frontal ",
  "Gerente Operaciones Senior ",
  "Gerente Planificacion Corporativo ",
  "Gerente Propio ",
  "Gerente Recursos Equipo Global ",
  "Gerente Recursos Humanos ",
  "Gerente Regional ",
  "Gerente regional ",
  "Gerente Relacion Industrial ",
  "Gerente Relaciones Publicas ",
  "Gerente Renta de vehiculos ",
  "Gerente Representante ",
  "Gerente senior ",
  "Gerente Servicio al Cliente ",
  "Gerente Servicio Tecnico ",
  "Gerente Servicios de Salud ",
  "Gerente Sistema de Informacion ",
  "Gerente Soporte Tecnico ",
  "Gerente Sucursal Regional ",
  "Gerente Tecnico ",
  "Gerente Tecnico Servicio de Operador",
  "Gerente Tecnologia de Informacion ",
  "Gerente TI ",
  "Gerente trabajo ",
  "Gerente Ventas Grupo ",
  "Gerente/Propio ",
  "Gerentes ",
  "Gerentes de Hotel ",
  "Gerentes de Operaciones ",
  "Gerentes de Registros ",
  "Gerentes Operaciones Administrativo ",
  "Gernete - Departamento Estandar Tecnico ",
  "Gestion - Fiabilidad del sistema",
  "Gestion de Configuracion ",
  "Gestion de Emergencia ",
  "Gestion de fuerza laboral",
  "Gestion de Salud ",
  "Gestor de Cambio ",
  "Gestor de Corredor ",
  "Gestor de Marca",
  "Gestor de propiedad ",
  "Gestor de Propiedad ",
  "Gestor de Trafico ",
  "Ginecologo ",
  "Golf Pro ",
  "Grabacion de Artista ",
  "Graficos ",
  "Granja ",
  "Granjero ",
  "Granjero / Paisajista",
  "Granjero de Pollo ",
  "Granjeros ",
  "Grupo Contable ",
  "Grupo de Credito y Gerente de Coleccion ",
  "Grupo de Negociosdirectro dev ",
  "Grupo Financiero C ",
  "Grupo Mgr - Medio Ambiente & Sostenible ",
  "Guardia de Seguridad ",
  "Guardia de seguridad/bombero y otras ocupaciones de servicios de protecci?n",
  "Guardian ",
  "Guaria de Seguridad ",
  "Guia ",
  "Guia de Gira ",
  "Guia Turistica ",
  "Guías de turismo y acompañantes",
  "Hecho redundante de Blue Cross ",
  "Herrero",
  "Hospital Spanish Town ",
  "Hotel",
  "Hotelero",
  "Huma Consultor ",
  "Ilustrador ",
  "Implementacion de Proyecto ",
  "Importador ",
  "Importador Comercial Informal",
  "Imprimir ",
  "Independiente Pro ",
  "Industria de Entretenimiento ",
  "Ingeniero ",
  "Ingeniero /Dibujante",
  "Ingeniero Bio Medico ",
  "Ingeniero Cambio Internacional ",
  "Ingeniero Civil ",
  "Ingeniero Computo y Electrico ",
  "Ingeniero Consultaria ",
  "Ingeniero Consultor ",
  "Ingeniero de Campo ",
  "Ingeniero de Computo ",
  "Ingeniero de Construccion ",
  "Ingeniero de Estructura ",
  "Ingeniero de Estudio ",
  "Ingeniero de Fabrica ",
  "Ingeniero de Gestion de Fallas",
  "Ingeniero de Instrumento ",
  "Ingeniero de lugar",
  "Ingeniero de Mantenimiento ",
  "Ingeniero de Maquina ",
  "Ingeniero de Operaciones ",
  "Ingeniero de procesamiento snr ",
  "Ingeniero de Red ",
  "Ingeniero de Software",
  "Ingeniero de sonido ",
  "Ingeniero de Trabajo ",
  "Ingeniero de Transmision ",
  "Ingeniero Disenador ",
  "Ingeniero Domestico ",
  "Ingeniero Electo ",
  "Ingeniero Electrico ",
  "Ingeniero en Computo ",
  "Ingeniero en Sistemas ",
  "Ingeniero Industrial ",
  "Ingeniero Lider ",
  "Ingeniero Marino ",
  "Ingeniero Mecanico ",
  "Ingeniero Residente ",
  "Ingeniero Retirado ",
  "Ingeniero Sistema Computo ",
  "Ingeniero Telecomunicaciones ",
  "Ingeniero Telefonico ",
  "Ingeniero Vas Seior ",
  "Ingenieros ",
  "Ingenieros de hardware informático",
  "Ingenieros Petroleros",
  "Ingenieros Químicos",
  "Inicio de Negocio de Pesca ",
  "Inspeccion de Factura ",
  "Inspecion de Laboratorio ",
  "Inspector ",
  "Inspector Bancario ",
  "Inspector de juegos",
  "Inspector de Policia ",
  "Inspector de Salud ",
  "Inspector de Transporte ",
  "Inspector de Vehiculo ",
  "Inspector Garantia de Calidad ",
  "Inspector Limpieza publica ",
  "Inspector Salud Publica ",
  "Inspector/Auditor ",
  "Inspectores de construcción y edificación",
  "Instalador de Sistema ",
  "Instaladores de alfombras",
  "Instructor ",
  "Instructor de Aerobicos",
  "Instructor de Conduccion ",
  "Instructor de Deportes ",
  "Instructor de Herbal Life ",
  "Instructor de Maquina de Bordado",
  "Instructor de Soldadura ",
  "Instructor de Vuelo ",
  "Instructor Desarollo de Educacion ",
  "Instructor Mecanico ",
  "Instrumentista",
  "Internacional ",
  "Interno ",
  "Interno de Psicologia ",
  "Interno Medico ",
  "Interno Medio Tiempo ",
  "Intertador ",
  "Interventor ",
  "Inversion ",
  "Inversiones/Empleado Contable Senior ",
  "Inversionista ",
  "Inversor Jubilado ",
  "Investigador ",
  "Investigador de acidentes y Seguridad ",
  "Investigador/profesor",
  "Investigadores de encuestas",
  "Jardineria ",
  "Jefe Arquitectura ",
  "Jefe Asistente Bomba ",
  "Jefe Contable ",
  "Jefe de Asistencia ",
  "Jefe de Comisario",
  "Jefe de departamento de matematicas ",
  "Jefe de Desarollo y Alcance ",
  "Jefe de Empleado ",
  "Jefe de enfermeria ",
  "Jefe de Ingeniero ",
  "Jefe de Mantenimiento de Ingeniero con ",
  "Jefe de Operaciones ",
  "Jefe de persona que Chequea ",
  "Jefe Director Tecnico ",
  "Jefe Division ",
  "Jefe Oficial de Finanzas ",
  "Jefe Oficial Ejecutivo ",
  "Jefe Operador de Bomba ",
  "Jefe Radiografo ",
  "Jefes de Estado/Pol?ticos y Altos Funcionarios del Gobierno",
  "Jinete ",
  "Joyero ",
  "Joyeros y trabajadores de piedras preciosas y metales",
  "Jubilado ",
  "Jueces",
  "Juez de Apelacion ",
  "Juez de Linea ",
  "Laminadores y fabricantes de fibra de vidrio",
  "Lavadero de Vehiculo ",
  "lci ",
  "Lectores de medidores",
  "Lectro de Metro ",
  "Libro Cortador-Carpeta",
  "Licencia de Pre retiro ",
  "Lider del Equipo ",
  "Lider del equipo /Cosmetologa",
  "Lider Del Equipo de Cobro",
  "Lider Equipo de Compra ",
  "Lider Equipo Scuba ",
  "Ligador de Queso ",
  "Limpiador ",
  "Limpiador Medio Tiempo ",
  "Limpiadores de vehículos y equipos",
  "Linea Tecnica ",
  "Linguista",
  "Locutor de Radio/Mezclador de Musica ",
  "Locutores de radio y televisión",
  "Logistica ",
  "M.D",
  "M.D ",
  "M.O.I",
  "Ma Consultoria ",
  "Maestro/Disenador ",
  "Maestro/Profesor ",
  "Magistrado Residente ",
  "Magistrado Residente Senior ",
  "Manejador de Correo ",
  "Manicurista ",
  "Mantener Red ",
  "Mantenimiento ",
  "Maquillista ",
  "Maquinista",
  "Maquinistas (fabricante de metales)",
  "Marina US ",
  "Marinero ",
  "Masajista ",
  "Masones (albañiles)",
  "Mayordomo ",
  "Mecanicas ",
  "Mecanico ",
  "Mecanico - Ingeniero ",
  "Mecanico / Operador de Taxi ",
  "Mecanico Aeronave",
  "Mecanico Automovilistico ",
  "Mecanico de mantenimiento ",
  "Mecanico de Maquina ",
  "Mecanico de Trabajo Pesado ",
  "Mecanico Deisel ",
  "Mecanico/Conductor Automotriz",
  "Mecanico/Tecnico Automovilistico ",
  "Mecanio Automotriz ",
  "Mecanografo ",
  "Mecanografo Jubilado ",
  "Medico ",
  "Medio Ambiente Nacional y Planificacion",
  "Menor ",
  "Mensajero ",
  "Mensajero de Efectivo ",
  "Mensajero Medio Tiempo ",
  "Mensajeros y Couriers",
  "Mercadeo ",
  "Mercadeo com ",
  "Mercadeo Corporativo Avp ",
  "Mercadeo de Hospitalidad ",
  "Mercadeo Profesional ",
  "Mercader **(Merchandiser) ",
  "Mercadologo ",
  "Mesero ",
  "Mezclador",
  "Mezclador de musica ",
  "Microbiologo de laboratorio Asociado",
  "Microbiólogos",
  "Miembro de compania de actores ",
  "Minero ",
  "Ministro de religion ",
  "Ministro de religion / profesor ",
  "Ministro General ",
  "Minorista ** (Merchandiser) ",
  "Misionero ",
  "Modelo ",
  "Modelos",
  "Molinero ",
  "Monitor de Inspeccion ",
  "Motor Aprendiz ",
  "Musico ",
  "Musico (Parte de una banda) ",
  "Musico /Baterista ",
  "N/A",
  "NA ",
  "Nana ",
  "Ncoic Financiero - Oficial Militar ",
  "Negocios ",
  "Ninera ",
  "Ninguno ",
  "Nino",
  "NiÑera ",
  "Nulo ",
  "Nutricionista ",
  "Obrero ",
  "Obstetra ",
  "Obstetra / Ginecologo ",
  "Ocupaciones de arquitectura e ingenier?a",
  "Ocupaciones de Construcci?n y Extracci?n",
  "Ocupaciones de gesti?n/asistente de gesti?n y supervisi?n de ocupaciones",
  "Ocupaciones de maestros/instructores educativos y bibliotecas",
  "Ocupaciones de oficina y apoyo administrativo",
  "Ocupaciones de operaciones comerciales y financieras",
  "Ocupaciones de transporte y movimiento de materiales",
  "Ocupaciones de ventas minoristas",
  "Ocupaciones inform?ticas y matem?ticas",
  "Ocupaciones relacionadas con la preparaci?n y el servicio de alimentos",
  "Oficial  Estado Senior ",
  "Oficial Administracion de Hipoteca ",
  "Oficial Administrativo ",
  "Oficial Administrativo Pdc ",
  "Oficial Administrativo snr ",
  "Oficial Ambiental Senior ",
  "Oficial Aprendiz ",
  "Oficial Bano Personal ",
  "Oficial Central Vector",
  "Oficial Certificado ",
  "Oficial Cientifico ",
  "Oficial Cientifico Estandar ",
  "Oficial Comercial ",
  "Oficial Cominicacion Cambio Comportamiento ",
  "Oficial Contable ",
  "Oficial Control Trafico Aereo",
  "Oficial Credito Especial ",
  "Oficial Credito Senior ",
  "Oficial Cuidado al Cliente ",
  "Oficial Cumplimiento de Seguridad ",
  "Oficial de adquisiciones ",
  "Oficial de Aduanas ",
  "Oficial de Aduanas senior ",
  "Oficial de Aduanas snr ",
  "Oficial de Banco ",
  "Oficial de Beneficios ",
  "Oficial de Campo ",
  "Oficial de Caso Senior ",
  "Oficial de Coleccion ",
  "Oficial de Compra ",
  "Oficial de Contabilidad snr ",
  "Oficial de correos/seguridad",
  "Oficial de Cortesia de Turismo ",
  "Oficial de Cumplimiento",
  "Oficial de Desarollo de Negocio ",
  "Oficial de desinversion",
  "Oficial de Disponibilidad de Red",
  "Oficial de Educacion en Servicio ",
  "Oficial de Educacion senior ",
  "Oficial de Entrenamiento ",
  "Oficial De Estado ",
  "Oficial de Evaluacion",
  "Oficial de Extension ",
  "Oficial de Hipoteca ",
  "Oficial de Implementacion ",
  "Oficial de Impuestos ",
  "Oficial de Informacion ",
  "Oficial de Inteligencia Snr ",
  "Oficial de Inversion ",
  "Oficial de Investigacion ",
  "Oficial de las fuerzas armadas ",
  "Oficial de Liquidacion y garantias snr ",
  "Oficial de Llamada ",
  "Oficial de Mantenimiento ",
  "Oficial de Mercadeo ",
  "Oficial de Mercadeo snr ",
  "Oficial de Mercado ",
  "Oficial de Migracion ",
  "Oficial de Migracion/Enfermera Registrada",
  "Oficial de Operacion",
  "Oficial de Operaciones ",
  "Oficial de Operaciones Snr ",
  "Oficial de Personal ",
  "Oficial de Policia ",
  "Oficial de Policia Jubilado ",
  "Oficial de Policia y analitico Senior ",
  "Oficial de Policia- corporal ",
  "Oficial de Prestamos ",
  "Oficial de Prestmo ",
  "Oficial de Procesamiento (Rjm2)",
  "Oficial de Programa Senior ",
  "Oficial de Protocolo y Enlace con Medios de Comunicacion",
  "Oficial de Proyecto ",
  "Oficial de Reaseguros ",
  "Oficial de Recuperacion de Deuda ",
  "Oficial de Registro ",
  "Oficial de Registros ",
  "Oficial de Relaciones ",
  "Oficial de RRHH ",
  "Oficial de Sanidad ",
  "Oficial de Seguridad ",
  "Oficial de Seguridad/Granjero ",
  "Oficial de Seguridad/Pintor ",
  "Oficial de Soporte de Negocios ",
  "Oficial de Soporte de Proyecto ",
  "Oficial de Tesoreria ",
  "Oficial de Vivienda ",
  "Oficial deEquipo y Diseno ",
  "Oficial del Ejercito ",
  "Oficial Desarollo de Carrera ** (Development)",
  "Oficial Desrollo Personal ",
  "Oficial Educacional ",
  "Oficial Electo ",
  "Oficial Entrada de datos ",
  "Oficial Gubernamental Senior ",
  "Oficial Hrd ",
  "Oficial Informacion Registros ",
  "Oficial Institucion Snr ",
  "Oficial Inversion Chef ** ",
  "Oficial Investigador Mercadeo ",
  "Oficial Jefe Operaciones ",
  "Oficial Legal ",
  "Oficial Legal Snr ",
  "Oficial Licencia ",
  "Oficial Medico ",
  "Oficial Mercadeo ",
  "Oficial Pastor ",
  "Oficial Pastor / mecanografa",
  "Oficial Prestamos Nuevos ",
  "Oficial Procesamiento de datos ",
  "Oficial Procesamiento de Transaccion ",
  "Oficial Proyectos Especial ",
  "Oficial Recursos Humanos ",
  "Oficial Registro/Servicio de Pagador de Impuesto ",
  "Oficial Relacion al Cliente ",
  "Oficial Relacion Cliente ",
  "Oficial Relacion de Comunidad ",
  "Oficial Relacione Publicas ",
  "Oficial Relaciones a Clientes ",
  "Oficial Relaciones de Empleado ",
  "Oficial Relaciones Humanad / Relaciones Publicas ",
  "Oficial Relaciones Publica ",
  "Oficial Reservado ",
  "Oficial Revision de Calidad ",
  "Oficial Seguridad Jubilado ",
  "Oficial Servicio al Cliente ",
  "Oficial Servicio de Invitado ",
  "Oficial Servicio Extranjero ",
  "Oficial Servicios Corporativo ",
  "Oficial Tecnico ",
  "Oficial Tecnico  Snr ",
  "Oficial Tecnico de lugar ",
  "Oficiales de libertad condicional y especialistas en tratamiento correccional",
  "Oficiales de policía y Sheriff",
  "Oficiales de seguridad ",
  "Oficina Evaluacion de Datos y Monitoreo ",
  "Oficina militar",
  "Oftalmologo",
  "Operacion de Paginas ",
  "Operaciones ",
  "Operaciones comerciales y financieras",
  "Operaciones Gerencial - ccsl",
  "Operaciones Movil Ejecutivo ",
  "Operaciones VP ",
  "Operaciones/Empleado Servicio al Cliente ",
  "Operador ",
  "Operador Autobus de gira ",
  "Operador Autobus/Gira",
  "Operador de Autobus",
  "Operador de Autobus ",
  "Operador de Autobus (Conductor)",
  "Operador de camiones de acarreo",
  "Operador de Central Electrica ",
  "Operador de Comedor ",
  "Operador de Comercio ",
  "Operador de Computo ",
  "Operador de Computo - Misionero ",
  "Operador de desodorizador",
  "Operador de entrada de datos ",
  "Operador de Equipo ",
  "Operador de Gira ",
  "Operador de grua ",
  "Operador de Maquina ",
  "Operador de Montacargas ",
  "Operador de Negocios",
  "Operador de Refineria ",
  "Operador de Remolque ",
  "Operador de Reparto ** (Cast Operater) ",
  "Operador de Sistema ",
  "Operador de Sistema de Computo ",
  "Operador de Taxi ",
  "Operador de taxi - Empleado Propio ",
  "Operador de Tienda ",
  "Operador de Tractor ",
  "Operador de Transporte ",
  "Operador de Unidad ",
  "Operador Entrada de Datos ",
  "Operador Limpieza de hogar ",
  "Operador Mantenimiento Planta Independiente ",
  "Operador Manufacturacion ",
  "Operador Proveedor Combinado ",
  "Operador Telefonico ",
  "Operador Telefonico/empleado Servicio al Cliente ",
  "Operador Terminal ",
  "Operador/dueno de taxi ",
  "Operadores de cámara",
  "Operadores de centralita",
  "Operadores de excavadoras y cargadores y de draga",
  "Operadores de grúas y otros equipos",
  "Operadores de máquinas de coser",
  "Operadores de planta y sistema",
  "Operadores de plantas de energía",
  "Operadores de plantas químicas y sistemas",
  "Operadores de radio",
  "Operadores de veh?culos motorizados y otros veh?culos de pasajeros",
  "Operadores de vehículos de motor",
  "Operadores y empleados de máquinas de envasado y llenado",
  "Oprador de Computo Junior ",
  "Optico ",
  "Ópticos",
  "Optometrista",
  "Optometristas",
  "Organizador de Donacion de Sangre",
  "Organizador de la Juventud para el Ministerio",
  "Orientador de Boda ",
  "Ortodoncistas",
  "Ortopedistas y Protésicos",
  "Otro ",
  "Oyente Representante de cuidado ",
  "P Cuidado Cliente ",
  "Paisajismo ",
  "Paisajista ",
  "Pala Mecanica ",
  "Panadería",
  "Panadero",
  "para primera banca mgr ",
  "Paralegal ",
  "Paralegal /oficina de Gerente ",
  "Paralegales / Asistentes legales / Otros trabajadores de apoyo legal",
  "Paramedico ",
  "Partera Registrada ",
  "Pasante de fisioterapeuta",
  "Pastor ",
  "Pastor mecanografa",
  "Pastor/Lector ",
  "Patologo ",
  "Patologo de lengua y habla ",
  "Patrocinador General ",
  "Patrocinador Unico ",
  "Pediatra ",
  "Pediatra senior ",
  "Peluquera ",
  "Peluqueria ",
  "Pendiente ",
  "Pensionado ",
  "Pensionado del gobierno retirado ",
  "Pensiones ",
  "Percusionista",
  "Perforadores de tierra",
  "Periodista ",
  "Persona de almacen ",
  "Persona de Cuenta Clave ",
  "Persona de Higiene dental ",
  "Persona de Sanidad ",
  "Persona de Venta ",
  "Persona de Venta Bienes Raices ",
  "Persona de Ventas - Seguro ",
  "Persona de Ventas Gnld ",
  "Persona encargada del campo ",
  "Persona que Asfalta",
  "Persona que Dibuja ",
  "Persona que enmarca ",
  "Personal de Banco ",
  "Personal de mantenimeinto ",
  "Personal de Tesoreria ",
  "Personal de Ventas",
  "Personal de Ventas/Emplado Escritura de carta ",
  "Personal del grupo ",
  "Personal Misionero ",
  "Personal TI ",
  "Pescadero ",
  "Pescador ",
  "Pescador/ Tapicero ",
  "Piloto ",
  "Piloto Aprendiz ",
  "Piloto de Aerolinea ",
  "Piloto Marino ",
  "Pilotos de avi?n e ingenieros de vuelo",
  "Pintor ",
  "Pintor Contratado ",
  "Pintores",
  "Pista y Campo - Atleta ",
  "Planificacion Estratégica y Corporativa",
  "Planificador ",
  "Planificador Corporativo ",
  "Planificador de Boda ",
  "Planificador de Cartera ",
  "Planificador de Eventos ",
  "Planificador de Transporte ",
  "Planificador Social - Servicio Civil ",
  "Plomer/Granjero ",
  "Plomero",
  "Podologo ",
  "Policia ",
  "Policia Corporal ",
  "Policia de distrito Especial ",
  "Politico ",
  "Politólogos",
  "Portador",
  "Portador/Secretaria",
  "Porteadores de equipaje y botones",
  "Portero ",
  "Portero Cap Redundante ",
  "Practica Familiar ",
  "Practica Privada ",
  "Practicante Holistico ** (Holistic Practitioner) ",
  "Practicante Media ",
  "Practicante Medico ",
  "Pre fijador clinico ",
  "pre jubilacion ",
  "Pregunta Seguridad ",
  "Prensadora ",
  "Prensadores",
  "Presentador ",
  "Presidente ",
  "Presidente - Restaurador ** (Restaurateur) ",
  "Presidente /CEO ",
  "Presidente Administrativo ",
  "Presidente CEO",
  "Presidente y CEO de CCfg ",
  "Presidente/ CEO ",
  "Primer Oficial (Piloto) ",
  "Princial Retirado ",
  "Principal ",
  "Principal de Escuela ",
  "Principal Retirado ",
  "Procesador Agronomo ",
  "Procesador de datos ",
  "Procesador de Reclamos ",
  "Procesador Transacion Financiero ",
  "Procesamiento ",
  "Procesamiento Datos/Sistemas ",
  "Procesamiento de Hipoteca ",
  "Produccion ",
  "Produccion de mariscos ",
  "Produccion de Musica ",
  "Productor de Cine ",
  "Productor de contenido del sitio web",
  "Productor de Mudica ",
  "Productor de registro/ Entretenimiento ",
  "Produtor ",
  "Produtor de Registro ",
  "Profesional Bienes Raices ",
  "Profesional de TI ",
  "Profesor ",
  "Profesor (Retirado)",
  "Profesor Aprendiz ",
  "Profesor Auxiliar",
  "Profesor de Baile ",
  "Profesor de Medicina ",
  "Profesor de Musica ",
  "Profesor de Piano ",
  "Profesor de quimica/Educador ",
  "Profesor Emerito ",
  "Profesor Entrenado ",
  "Profesor Estudiante ",
  "Profesor Jubilado ",
  "Profesor Lider ",
  "Profesor Medio tiempo ",
  "Profesor pre entrenado / dador de cuidado ",
  "Profesor Senior ",
  "Profesor Senior Interino ",
  "Profesor Snr ",
  "Profesor Titular ",
  "Profesor universitario",
  "Profesor/Cordinador de Grado ",
  "Profesor/Granjero ",
  "Profesor/Musico ",
  "Profesor/Soldado de Reserva ",
  "Profesora ",
  "Profesora de escuela secundaria ",
  "Profesora/Catedratico ",
  "Profesora/Principal ",
  "Profesores e instructores",
  "Profesoro pre entrenado ",
  "Programador ",
  "Programador de Computo ",
  "Promotor ",
  "Promotor de Entretenimiento ",
  "Promotor de Ventas",
  "Promotores de productos",
  "Propiedad de Empleado/ Administrador de Sistema ",
  "Propietario ",
  "Propietario de Hogar ",
  "Propietario de la tienda de comestibles",
  "Propietario de Negocio ",
  "Propietario de Negocio/ Empresario ** (Entrepreneur) ",
  "Propietario del comercio ",
  "Propietario del sistema de entretenimiento",
  "Propio / Director ",
  "Propio/Operador ",
  "Protesis Dental ",
  "Provedor de Transporte ",
  "Proveedor ",
  "Proveedor Cuidado de ninos ",
  "Prs ",
  "Psicologia ",
  "Psiquiatra ",
  "Publicacion ",
  "Publicidad ",
  "Punto focal RRHH",
  "Quimico ",
  "Quiroprácticos",
  "RadioDifusora",
  "Radiografo ",
  "Radiologo ",
  "Recaudadores de facturas y cuentas",
  "Recepcionista ",
  "Recepcionista Medico ",
  "Recepcionista/Operador Telefonico ",
  "Recervaciones ",
  "Reclamo Empleado ",
  "Reclutador ",
  "Recnico de Radio ",
  "Recnico de Registro ",
  "Recolectores de basura y material reciclable (basurero)",
  "Recursos Humanos ",
  "Recursos Humanos VP ",
  "Redactor publicitario",
  "Redundante",
  "Redundante ",
  "Redundante de envio carib star ",
  "Reepcionista de Seguridad ",
  "Regional Urbano ",
  "Registra Asistente Senior ",
  "Registrar ",
  "Registrar Departamento ",
  "Registro de salud ",
  "Registro geologico",
  "Registro Medico ",
  "Regulacion Legal VP ",
  "Regulador de Almacen ",
  "Relacion al cliente ",
  "Relacion Publica ",
  "Relaciones al Cliente ",
  "Reparacion Automovilistico ",
  "Reparaciones Automotriz",
  "Reparador automovilistico **  (Auto Body Repairmn) ",
  "Reparadores de cámaras y equipos fotográficos",
  "Reparadores de electrodomésticos",
  "Reparadores de llantas y cambiadores",
  "Repartidor ",
  "Repartidor / Oficina Personal de Mantenimiento ",
  "Repartidor/Persona de Venta ",
  "Reporte de Negocios ",
  "Reportero ",
  "Reporteros y corresponsales",
  "Repostero ",
  "Representante ",
  "Representante al cliente ",
  "Representante Cliente ",
  "Representante cliente ",
  "Representante Comercial ",
  "Representante Comercial ** (Solicitor)",
  "Representante Cuidado Cliente ",
  "Representante Cuidado Cliente / Entrenamiento Cardiaco ",
  "Representante de Aerolinea ",
  "Representante de Cobros snr ",
  "Representante de Concepcionario ",
  "Representante de Mercado ",
  "Representante de Reclamos ",
  "Representante de seguro ",
  "Representante de Venta Tecnico ",
  "Representante de Ventas ",
  "Representante de Ventas al mercado de Carnes",
  "Representante de Ventas de Seguro ",
  "Representante de Ventas de techo ",
  "Representante de Ventas snr ",
  "Representante Framaceutico ",
  "Representante Medico ",
  "Representante Mercadeo ",
  "Representante Promosiones ",
  "Representante Reservacion Destinatario ",
  "Representante Seguridad de Calidad ",
  "Representante Servicio al cliente ",
  "Representante Servicio al Cliente ",
  "Representante Servicio al cliente snr ",
  "Representante Servicio de Miembro ",
  "Representante Servicio Personal ",
  "Representante Servicio Tecnico ",
  "Representante Servicio Telefonicos ",
  "Representante Servicios Telefonicos ",
  "Representante Telefonico ",
  "Representante Televentas ",
  "Representante Ventas ",
  "Representante Ventas al Cliente ",
  "Repuestos ",
  "Reservaciones ",
  "Residente",
  "Restaurante ",
  "Retirado ",
  "Retirado / ama de casa",
  "Retirado /ama de llaves ",
  "Retirado/Pensionado ",
  "Reuso de Mercadeo ",
  "Revendedor de cobustible ",
  "Reverendo ",
  "Revisor de cumplimiento",
  "S.A.A",
  "S.L.U",
  "Sacerdote ",
  "Sacerdote Catolico Romano ",
  "Sacerdote Rc",
  "Salud Regional ",
  "Salvavida ",
  "Salvavidas",
  "Sanidad Comunitaria ",
  "Sargento ",
  "Sargento de Policia ",
  "Sastre ",
  "Sastres",
  "Se Seguridad ",
  "Secretaria ",
  "Secretaria Administrativa",
  "Secretaria de Compania ",
  "Secretaria Legal ",
  "Secretaria para personal ",
  "Secretaria paralegal ",
  "Secretaria Permanente ",
  "Secretaria/Tesorero ",
  "Secretario / Empleado entrada datos",
  "Secretario Bilingue ",
  "Secretario de Impuestos ",
  "Secretario de Subscripcion ",
  "Secretario Ejecutivo ",
  "Secretario ejecutivo retirado ",
  "Secretario Legal ",
  "Secretario Senior ",
  "Secretario/ Taquigrafo **(Stenographer)",
  "Seguridad ",
  "Seguridad Empresarial ",
  "Seguro de Vida ",
  "Servicio al Cliente ",
  "Servicio al Cliente - Interno ",
  "Servicio al Cliente snr ",
  "Servicio al cliente/ Entrada de datos",
  "Servicio Automotriz Técnicos y Mecánicos",
  "Servicio de inscripcion ",
  "Servicio de Limpieza ",
  "Servicio de Provedor ",
  "Servicio de Ventas ",
  "Servicios Asseso Informacion Documentacion jnr ",
  "Servicios de Invitados ",
  "Servicios Diagnostico y Terapeutico ",
  "Servicios Tecnologia Informacion Mona ",
  "Servidor ",
  "Servidor Civil Internacional ",
  "Servidor Civil Jubilado ",
  "Servidor de comedor",
  "Servidor Publico Jubilado ",
  "Servidor/Camarero ",
  "Servidores de fosas sépticas y limpiadores de tuberías de alcantarillado",
  "Sky Cap Porter",
  "Snr. Vp For ",
  "Sociólogos",
  "Soldado ",
  "Soldado US ",
  "Soldado/ Tecnico de Aeronaves",
  "Soldador",
  "Soldador ",
  "Soldador - Corporal ",
  "Soldador Jubilado ",
  "Soldadores",
  "Soldando ",
  "Soporte Administrativa ",
  "Soporte al Centro Cibernetico",
  "Soporte Cliente ",
  "Soporte de cliente ",
  "Soporte Movil ",
  "Soporte Tecnico ",
  "Sous Chef ",
  "sub contratista ",
  "Sub contratista ",
  "sub contratista - Pintor ",
  "Subastador ** (Auctioneer)",
  "Subscripcion ",
  "Suervisor entrada de datos ",
  "Superintendente ",
  "Superintendente de Construccion ",
  "Superintendente de Policia ",
  "Superintendente de trabajo Especial ",
  "Superintendente Interino ",
  "Supervidor de Impresion ",
  "Supervisor ",
  "supervisor - Gerente de Hospitalidad ",
  "Supervisor (Ingeniero) ",
  "Supervisor Almacen ",
  "Supervisor Area de Ventas",
  "Supervisor Asistente de Almacen",
  "Supervisor Bancario ",
  "Supervisor Contable ",
  "Supervisor Contratista ",
  "Supervisor de Administracion ",
  "Supervisor de Auditoria ",
  "Supervisor de Aviacion ",
  "Supervisor de Bar ",
  "Supervisor de Boveda ",
  "Supervisor de Caja ",
  "Supervisor de Campo ",
  "Supervisor de Casino ",
  "Supervisor de Comedor ",
  "Supervisor de Compra ",
  "Supervisor de concesionario",
  "Supervisor de Construccion ",
  "Supervisor de Distribuidor",
  "Supervisor de Fabrica ",
  "Supervisor de Inventario ",
  "Supervisor de Limpieza ",
  "Supervisor de Lugar ",
  "Supervisor de Mantenimiento ",
  "Supervisor de Mercadeo ",
  "Supervisor de pago de nomina ",
  "Supervisor de Planta Hidraulica ",
  "Supervisor de Produccion ",
  "Supervisor de Producto Senior ",
  "Supervisor de Reservaciones ",
  "Supervisor de Restaurante ",
  "Supervisor de Seguridad ",
  "Supervisor de Servicios Financieros ",
  "Supervisor de Tienda ",
  "Supervisor de Trabajo Senior ",
  "Supervisor de Unidad ",
  "Supervisor de Ventas ",
  "Supervisor Directiva de Alojamiento ",
  "Supervisor Interino ",
  "Supervisor Mercado ",
  "Supervisor Operaciones ",
  "Supervisor Operaciones de Vuelo ",
  "Supervisor practicante ",
  "Supervisor receptor ",
  "Supervisor Representante ",
  "Supervisor RRHH ",
  "Supervisor Secretaria/ama de casa",
  "Supervisor Senior ",
  "Supervisor Servicio al cliente ",
  "Supervisor Tecnico ",
  "Supervisor Terminal ",
  "Supervisor Unma ",
  "Supervisores ",
  "Supervisores de manejo de carga de aeronaves",
  "Supervsior de produccion",
  "Suplente de Adminsitracion ",
  "Suplente Enfermera Encargada ",
  "Suplente Grupo pr ",
  "Suplente superintendente ",
  "Tallador de Herramientas ",
  "Tapizado ",
  "Tapizado **(Upholster) ",
  "Tapizado y montaje de muebles",
  "Tapizando ",
  "Tapizar ** (Upholster) ",
  "Taquigrafo Confidencial",
  "Tasador ",
  "Tasador de Bienes Raices ",
  "Tasador de Seguros ",
  "Tasadores y Asesores de Bienes Raíces",
  "Tasadores y asesores de vehículos automotores",
  "Taylor ",
  "Te Audio Visual ",
  "Tec. Desempleado ",
  "Techador ",
  "Tecnica en unas ",
  "Tecnico ",
  "Tecnico - Contrato ",
  "Tecnico - Director ",
  "Tecnico Aire Acondicionado ",
  "Tecnico Aire Acondicionado y Refrigeracion ",
  "Tecnico Aire Acondicionado/Granjero ",
  "Tecnico Aire Acondicionado/Refrigerador ",
  "Tecnico Asociado",
  "Tecnico Automotriz",
  "Tecnico Automovilistico",
  "Tecnico canales electrico ",
  "Tecnico Contable ",
  "Tecnico de Computo ",
  "Tecnico de computo Desempleado ",
  "Tecnico de Construccion ",
  "Tecnico de Despacho ",
  "Tecnico de Facilidades ",
  "Tecnico de Farmacia ",
  "Tecnico de game box ",
  "Tecnico de Gas ",
  "Tecnico de Laboratorio ",
  "Tecnico de Lector de huella ",
  "Tecnico de Mantenimiento ",
  "Tecnico de Operacion",
  "Tecnico de Refigerador ",
  "Tecnico de Repracion ",
  "Tecnico de Servicio de Campo ",
  "Tecnico de T.I",
  "Tecnico de Telefono",
  "Tecnico de Telefono ",
  "Tecnico de Television ",
  "Tecnico de TV ",
  "Tecnico de Ventas ",
  "Tecnico Dental ",
  "Tecnico Electrico ",
  "Tecnico Electronico ",
  "Tecnico en Comunicacion ",
  "Tecnico en investigacion ",
  "Tecnico en Repracion ",
  "Tecnico en Sistemas ",
  "Tecnico Espanol ",
  "Tecnico Farmaceutico ",
  "Tecnico Fotografico ",
  "Tecnico Hidraulica ",
  "Tecnico Ingenieria",
  "Tecnico Inspector ",
  "Tecnico Jefe ",
  "Tecnico Lab Computo ",
  "Tecnico Laboratorio Senior ",
  "Tecnico Mecanico ",
  "Tecnico Media ",
  "Tecnico Medico de Emergencia ",
  "Tecnico Mejora Automovilistico ",
  "Tecnico Metrico ",
  "Tecnico Refrigerador ",
  "Tecnico Visual ",
  "Tecnico/ Gerente ",
  "Tecnicos biologicos",
  "Tecnicos Cuentas Mayor ",
  "Técnicos de equipos de audio y video",
  "Técnicos de tráfico",
  "Técnicos psiquiátricos",
  "Tecnido de Musica ",
  "Tecnido de Produccion ",
  "Tecnoligista de informacion",
  "Tecnoligista de información",
  "Tecnologia Rayos X ",
  "Tecnologo de laboratorio ",
  "Tecnologo Medico ",
  "Tecnologo Medico Snr ",
  "Tecnólogos Quirúrgicos",
  "Tecnólogos y técnicos cardiovasculares",
  "Telecomunicaciones ",
  "Terapeuta de Belleza **(Beauty Therapist)",
  "Terapia Ocupacional ",
  "Terapista ",
  "Terapista Fisico ",
  "Terapista Fisico Ortopeda ",
  "Terapista Ocupacional ",
  "Terminal Tecnico ",
  "Tesorero ",
  "Tienda ",
  "Tienda Comestibles - Dueno ",
  "Tienda de merceria",
  "Tienda Partes Automovilistica",
  "Topografo ",
  "Topografo Cantidad ",
  "Topografo/Inspector Marino ",
  "Trabaja cuenta propia ",
  "Trabajador Agricola ",
  "Trabajador Auxiliar ",
  "Trabajador Casual ",
  "Trabajador de Construccion ",
  "Trabajador portuario",
  "Trabajador Postal ",
  "Trabajador Social ",
  "Trabajador social Jubilado ",
  "Trabajadores de cuidado infantil",
  "Trabajadores de lavandería y tintorería",
  "Trabajadores de medios y comunicación",
  "Trabajadores de oficina y apoyo administrativo",
  "Trabajadores de servicios de juegos",
  "Trabajadores de servicios de protección",
  "Trabajadores de soporte legal",
  "Trabajadores del Transporte A?reo",
  "Trabajadores forestales y de conservación",
  "Trabajadores religiosos",
  "Trabajadores Sociales y Consejero",
  "Trabajadores y reparadores de calzado y cuero",
  "Trabajdor Temporal ",
  "Trabajo de Produccion ",
  "Trabajo del Hogar",
  "Trabajo en el Extranjero ",
  "Traductor ",
  "Transporte ",
  "Transportista",
  "Tutor ",
  "Tutor - asistente Biologo / Tecnico ** (Technician)",
  "Tutor Aplicacion de Computo ",
  "Tutor de Enfermeria ",
  "Unidad Comercial Lider del Equipo ",
  "Universidad de Tecnologia ",
  "V.P Bitu ",
  "Vehiculo para legal ",
  "Vendedor ",
  "Vendedor Ambulante ",
  "Vendedor Chofer ",
  "Vendedor de Arte ",
  "Vendedor de Asado ",
  "Vendedor de fruta y vegetales ",
  "Vendedor de Miel ",
  "Vendedor Pajilla ",
  "Vendedor Telefonico ",
  "Vendedor- Empleado Propio ",
  "Vendedora ",
  "Vendedores ambulantes y de periódicos",
  "Venta de distribuidores",
  "Ventas ",
  "Ventas Bienes Raices ",
  "Ventas de Seguro ",
  "Ventas Regional",
  "Ventas- Distribucion ",
  "Ventas-clientes",
  "Ventas/Mercadeo Administrativo ",
  "Ver Cliente #1306468",
  "Verificacion Clerk ",
  "Verificador Rrc Senior ",
  "Veterinario ",
  "Veterinario ** (Veterinarian) ",
  "Vice Asistente ",
  "Vice Presidente ",
  "Vice Presidente - Banquero ",
  "Vice Presidente - Banquero ** VICE ",
  "Vice Presidente Corporativo ",
  "Vice Presidente Ejecutivo ",
  "Vice Principal ",
  "Vice Principal - Alto Carthy Clan ",
  "Vice Principal - Escuela Windsor ",
  "Vie Principal ",
  "Vigilante/Trabajador de cocina",
  "Visitador de Salud Publica ",
  "Vivir en ayuda ",
  "Vivir en un centro de cuidado ",
  "Vmbs CEO Retirado ",
  "Vocalista ",
  "Voluntario ",
  "Voluntario Mor** ",
  "VP ",
  "VP de Cartera y Servicio al cliente ",
  "VP- Gestion Riesgo y pension ",
  "VP- Oficial de negociacion snr ",
  "Zoologo ",
  "Zoólogos y Biólogos de Vida Silvestre"
];